<template>
  <div id="article">
    <form v-on:submit.prevent>
      <div class="row">
        <div class="col-1">
          <div id="sidebar-menu" class="main_menu_side hidden-print main_menu">
            <div v-if="languageCode == 'en'">
              <p>Scroll to:</p>
              <a href="" v-on:click.prevent="scrollTo('edit-top')">Top</a>
              <a href="" v-on:click.prevent="scrollTo('section-title')">Title</a>
              <a v-if="article_data.contributors && article_data.contributors.length && !isTrad" href=""
                v-on:click.prevent="scrollTo('section-contribs')">Authors</a>
              <a v-if="isPCJ && article_data.abstracts && article_data.abstracts.length" href=""
                v-on:click.prevent="scrollTo('section-abstracts')">Abstract</a>
              <a v-else-if="isTrad && abstract_text" href=""
                v-on:click.prevent="scrollTo('section-abstracts')">Abstract</a>
              <a v-if="kwds_text.length" href="" v-on:click.prevent="scrollTo('section-keywords')">Keywords</a>
              <a v-if="isTrad" href="" v-on:click.prevent="scrollTo('section-fulltext')">Full text</a>
              <a v-if="!isPCJ && !isTrad && article_data.subjs && article_data.subjs.length" href=""
                v-on:click.prevent="scrollTo('section-subjs')">Subjects</a>
              <a v-if="article_data.is_staff && article_data.bibitems && !isTrad" href=""
                v-on:click.prevent="scrollTo('section-bibitems')">References</a>
            </div>
            <div v-else>
              <p>Accéder à:</p>
              <a href="" v-on:click.prevent="scrollTo('edit-top')">Début</a>
              <a href="" v-on:click.prevent="scrollTo('section-title')">Titre</a>
              <a v-if="article_data.contributors && article_data.contributors.length && !isTrad" href=""
                v-on:click.prevent="scrollTo('section-contribs')">Auteur.rice</a>
              <a v-if="isPCJ && article_data.abstracts && article_data.abstracts.length" href=""
                v-on:click.prevent="scrollTo('section-abstracts')">Résumé</a>
              <a v-else-if="isTrad && abstract_text" href=""
                v-on:click.prevent="scrollTo('section-abstracts')">Résumé</a>
              <a v-if="kwds_text.length" href="" v-on:click.prevent="scrollTo('section-keywords')">Mots clés</a>
              <a v-if="isTrad" href="" v-on:click.prevent="scrollTo('section-fulltext')">Texte intégral</a>
              <a v-if="!isPCJ && !isTrad && article_data.subjs && article_data.subjs.length" href=""
                v-on:click.prevent="scrollTo('section-subjs')">Sujets</a>
              <a v-if="article_data.is_staff && article_data.bibitems && !isTrad" href=""
                v-on:click.prevent="scrollTo('section-bibitems')">References</a>
            </div>
          </div>

          <div class="bottom-screen">
            <div v-if="!isTrad" class="dropdown">
              <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton-insert"
                data-bs-toggle="dropdown" aria-expanded="false">Insert</button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton-insert">
                <li><a class="dropdown-item" v-on:click="insert_author()">Author</a></li>
                <li v-if="!article_data.abstracts || !article_data.abstracts.length"><a class="dropdown-item"
                    v-on:click="insert_abstract()">Abstract</a></li>
                <li v-if="!kwds_text.length"><a class="dropdown-item" v-on:click="insert_kwds()">Keywords</a></li>
                <li v-if="!isTrad && !isPCJ"><a class="dropdown-item" v-on:click="insert_subj()">Subject</a></li>
                <li v-if="article_data.is_staff"><a class="dropdown-item" v-on:click="setChangeRef(false)"
                    data-bs-toggle="modal" data-bs-target="#referenceModal">Reference</a></li>
              </ul>
            </div>
            <div v-if="languageCode == 'en'" style="margin-top: 10px">
              <button v-if="!is_editable" disabled id="id-save" class="btn"
                v-bind:class="{ 'btn-primary-trad': isTrad, 'btn-primary': !isTrad }"
                v-on:click="saveForm(false)">Save</button>
              <button v-else-if="isTrad" id="id-save" class="btn"
                v-bind:class="{ 'btn-primary-trad': isTrad, 'btn-primary': !isTrad }"
                v-on:click="saveForm(false)">Save</button>
              <button v-else-if="isPCJ" id="id-save" class="btn"
                v-bind:class="{ 'btn-primary-trad': isTrad, 'btn-primary': !isTrad }"
                v-on:click="checkTopics(); saveForm(false)">Save</button>
              <p id="id-save-text"></p>
            </div>
            <div v-else style="margin-top: 10px">
              <button v-if="!is_editable" disabled id="id-save" class="btn"
                v-bind:class="{ 'btn-primary-trad': isTrad, 'btn-primary': !isTrad }"
                v-on:click="saveForm(false)">Sauvegarder</button>
              <button v-else id="id-save" class="btn"
                v-bind:class="{ 'btn-primary-trad': isTrad, 'btn-primary': !isTrad }"
                v-on:click="saveForm(false)">Sauvegarder</button>
              <p id="id-save-text"></p>
            </div>
          </div>
        </div>
        <div class="col-11" v-bind:class="{ 'with-anchor': isTrad }" id="edit-top">
          <div v-if="!article_data.is_staff && !isTrad" class="mt-4">
            <p>Fill the following form with the title, all authors details (first name, last name, affiliation, Email of
              the author for correspondence) and the abstract</p>
          </div>
          <div v-if="isTrad && !is_editable" class="alert alert-secondary col-10" role="alert">
            <span v-if="article_data.is_staff">This translation has been accepted and cannot be edited.</span>
            <span v-else>This translation has been submitted, you can no longer edit it.</span>
          </div>

          <div v-if="isTrad && !isTranslatedArticleComplete()">
            <div v-if="languageCode == 'en'">
              <div id="info_to_fill" class="alert alert-info col-xs-12 col-md-6">
                <p>Your article is not yet ready for submission. Please fill in the following information:</p>
                <ul>
                  <li v-if="!areTranslatorsComplete()">First name, last name and email of the translator(s)</li>
                  <li v-if="!is_title_already_translated && !trans_article.title_tex.length">Translated title</li>
                  <li v-if="!is_abstract_already_translated && !trans_abstract_text.length">Translated abstract</li>
                  <li v-if="!is_kwd_already_translated && kwds_text.length && !trans_kwds_text.length">Translated
                    keywords</li>
                  <li v-if="trans_body_html == getCssText()">Translated full text</li>
                </ul>
              </div>
              <p><button class="btn btn-lg btn-success disabled">Next</button></p>
            </div>
            <div v-else>
              <div id="info_to_fill" class="alert alert-info col-xs-12 col-md-6">
                <p>Votre article n'est pas encore prêt pour la soumission. Veuillez renseigner les informations
                  suivantes :</p>
                <ul>
                  <li v-if="!areTranslatorsComplete()">Prénom, nom et adresse mail du/des tranducteur(s)</li>
                  <li v-if="!is_title_already_translated && !trans_article.title_tex.length">La traduction du titre</li>
                  <li v-if="!is_abstract_already_translated && !trans_abstract_text.length">La traduction du résumé</li>
                  <li v-if="!is_kwd_already_translated && kwds_text.length && !trans_kwds_text.length">La traduction des
                    mots clés</li>
                  <li v-if="trans_body_html == getCssText()">La traduction du texte de l'article</li>
                </ul>
              </div>
              <p><button class="btn btn-lg btn-success disabled">Suivant</button></p>

            </div>
          </div>
          <div v-else-if="isTrad && is_editable">
            <div v-if="languageCode == 'en'">
              <button class="btn btn-lg btn-success" v-on:click="saveForm(true)">Next</button>
            </div>
            <div v-else>
              <button class="btn btn-lg btn-success" v-on:click="saveForm(true)">Suivant</button>
            </div>
          </div>
          <div v-if="isPCJ">
            <div v-if="!is_pcj_article_valid" class="alert alert-danger col-xs-12 col-md-6">
              <strong>To proceed with the submission process, please complete the required information, save, and click
                the 'Next' button.</strong>
              <ul>
                <li v-if="!is_pcj_title_article_provided"> Title of you article.</li>
                <li v-if="!is_pcj_article_abstract_provided"> Abstract of you article.</li>
                <li v-if="!is_single_topic_override || is_single_topic_override == 'false' && topicsSet.size == 1">
                  Confirm your choice of only one topic or choose one or two more.</li>
                <li v-else-if="!is_single_topic_override || is_single_topic_override == 'false' && topicsSet.size == 0">
                  Please select at least one (and up to three) topic(s).</li>
              </ul>
            </div>
            <div v-else-if="is_submission_dirty" class="alert alert-success col-xs-12 col-md-6">
              <strong>Please click on "Next" to continue your submission.</strong>
            </div>

          </div>
          <div v-if="isPCJ && !is_pcj_article_valid">
            <button class="btn btn-lg btn-success disabled">Next</button>
          </div>
          <div v-else-if="isPCJ && is_pcj_article_valid && is_editable">
            <a class="btn btn-lg btn-success" @click="nextPCJ(false, PCJSubmissionURL)">Next</a>
          </div>


          <!--  Authors section of Translations -->
          <div class="col-9">
            <div v-if="isTrad" id="section-contribs-trans">
              <div v-if="languageCode == 'en'">
                <div class="article-heading"><span>Authors of the translation</span></div>
                <div v-for="(contrib, index) in trans_article.contributors" v-bind:key="contrib.contrib_xml"
                  class="sc-card" v-bind:id="'section-contribs-trans-' + index">
                  <div class="se-label">Person</div>
                  <div class="sc-default-model">
                    <div class="ref-type">
                      <div class="float-end">
                        <button v-if="index > 0" class="btn btn-outline-secondary btn-sm"
                          v-on:click="moveAuthor(index, -1)"><i class="bi bi-arrow-up"></i></button>
                        <button v-if="index < trans_article.contributors - 1" class="btn btn-outline-secondary btn-sm"
                          v-on:click="moveAuthor(index, 1)"><i class="bi bi-arrow-down"></i></button>
                      </div>
                      <div class="se-header">{{ stringName(contrib.first_name, contrib.last_name) }}</div>
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label"><span class="required-field">*</span> First name</div>
                      <input type="text" class="sc-text-input se-editor" v-model="contrib.first_name" />
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label"><span class="required-field">*</span> Last name</div>
                      <input type="text" class="sc-text-input se-editor" v-model="contrib.last_name" />
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label"><span class="required-field">*</span> Email</div>
                      <input type="email" class="sc-text-input se-editor" v-model="contrib.email" />
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label">
                        Affiliation
                        <span
                          title="Several affiliations can be declared. Each affiliation must be reported on a single line and the different affiliations must be reported on different lines"><i
                            class="bi bi-question-circle text-primary fs-6"></i></span>
                      </div>
                      <textarea class="sc-textarea-input" v-model="contrib.address_text"></textarea>
                    </div>
                    <div class="sc-form-row" v-bind:class="[contrib.is_author_orcid_invalid ? 'invalid-field' : '']">
                      <div class="se-label">ORCID</div>
                      <input type="text" class="sc-text-input se-editor" pattern="\w{4}-\w{4}-\w{4}-\w{4}"
                        placeholder="0000-0000-0000-0000" @paste="handleOrcidInputPaste($event, contrib)"
                        v-model="contrib.orcid" />
                    </div>
                    <div class="se-footer">
                      <div class="float-end">
                        <button href="#deletePersonModal" class="btn btn-outline-secondary btn-sm"
                          data-bs-toggle="modal" @click="sendInfo(index)"><i class="bi bi-trash"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sc-plus">
                  <button class="btn btn-outline-secondary" v-on:click="insert_author()">Add an author</button>
                </div>
              </div>
              <div v-else>
                <div class="article-heading"><span>Auteur de la traduction</span></div>
                <div v-for="(contrib, index) in trans_article.contributors" v-bind:key="contrib.contrib_xml"
                  class="sc-card" v-bind:id="'section-contribs-trans-' + index">
                  <div class="se-label">Personne</div>
                  <div class="sc-default-model">
                    <div class="ref-type">
                      <div class="float-end">
                        <button v-if="index > 0" class="btn btn-outline-secondary btn-sm"
                          v-on:click="moveAuthor(index, -1)"><i class="bi bi-arrow-up"></i></button>
                        <button v-if="index < trans_article.contributors - 1" class="btn btn-outline-secondary btn-sm"
                          v-on:click="moveAuthor(index, 1)"><i class="bi bi-arrow-down"></i></button>
                      </div>
                      <div class="se-header">{{ stringName(contrib.first_name, contrib.last_name) }}</div>
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label"><span class="required-field">*</span> Prénom</div>
                      <input type="text" class="sc-text-input se-editor" v-model="contrib.first_name" />
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label"><span class="required-field">*</span>Nom</div>
                      <input type="text" class="sc-text-input se-editor" v-model="contrib.last_name" />
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label"><span class="required-field">*</span>Couriel</div>
                      <input type="email" class="sc-text-input se-editor" v-model="contrib.email" />
                    </div>
                    <div class="sc-form-row">
                      <div class="se-label">
                        Affiliation
                        <span
                          title="Several affiliations can be declared. Each affiliation must be reported on a single line and the different affiliations must be reported on different lines"><i
                            class="bi bi-question-circle text-primary fs-6"></i></span>
                      </div>
                      <textarea class="sc-textarea-input" v-model="contrib.address_text"></textarea>
                    </div>
                    <div class="sc-form-row" v-bind:class="[contrib.is_author_orcid_invalid ? 'invalid-field' : '']">
                      <div class="se-label">ORCID</div>
                      <input type="text" class="sc-text-input se-editor" pattern="\w{4}-\w{4}-\w{4}-\w{4}"
                        placeholder="0000-0000-0000-0000" @paste="handleOrcidInputPaste($event, contrib)"
                        v-model="contrib.orcid" />
                    </div>
                    <div class="se-footer">
                      <div class="float-end">
                        <button href="#deletePersonModal" class="btn btn-outline-secondary btn-sm"
                          data-bs-toggle="modal" @click="sendInfo(index)"><i class="bi bi-trash"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="sc-plus">
                  <button class="btn btn-outline-secondary" v-on:click="insert_author()">Ajouter un auteur</button>
                </div>
              </div>

            </div>
          </div>

          <div>
            <div v-if="languageCode == 'en'">
              <div v-if="isTrad" class="row" style="text-align: center; margin-top: 60px">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <h2>Original Language: <span v-html="article_data.vo_display_lang"></span></h2>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <h2>Translation language: <span v-html="article_data.trans_display_lang"></span></h2>
                  <br />
                  <p v-if="is_editable">Please fill in the information below</p>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="isTrad" class="row" style="text-align: center; margin-top: 60px">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <h2>Langue originale: <span v-html="article_data.vo_display_lang"></span></h2>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <h2>Langue de traduction: <span v-html="article_data.trans_display_lang"></span></h2>
                  <br />
                  <p v-if="is_editable">Veuillez remplir les informations ci-dessous</p>
                </div>
              </div>
            </div>

            <div v-if="!isTrad" v-bind:class="[isPCJ ? 'max-1200' : 'max-800']">
              <div class="article-heading"><span>Article basic information</span></div>
              <div class="sc-card">
                <div class="se-label"></div>
                <div class="sc-default-model">
                  <div v-if="!isPCJ" class="sc-form-row">
                    <div class="se-label">Language</div>
                    <select class="sc-text-input se-editor" name="article_lang" v-model="article_data.lang">
                      <option value="en">English</option>
                      <option value="fr">French</option>
                    </select>
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">Type</div>
                    <select v-model="article_data.atype" id="article_type" class="sc-text-input se-editor">
                      <option v-for="(value, key, index) in all_types" :value="key">{{ value }}</option>
                    </select>
                  </div>
                  <div v-if="isPCJ" class="sc-form-row" style="margin-bottom: 30px;">
                    <div class="se-label">Topics <span
                        title="Select at least 1 topic, up to 3. Pre-defined topics cannot be deselected"><i
                          class="bi bi-question-circle text-primary fs-6"></i></span></div>
                    <select v-model="topics" @change="checkTopics" id="article_topics" class="sc-text-input se-editor"
                      multiple="multiple" data-max-options="3"
                      title="Select at least 1 topic, up to 3. Pre-defined topics cannot be deselected"
                      data-width="100%">
                      <optgroup v-for="group in all_topics" :label="group['discipline']">
                        <option v-for="topic in group['topics']" :value="topic" :selected="isTopicMandatory(topic)"
                          :disabled="isTopicMandatory(topic)">{{ topic }}</option>
                      </optgroup>
                    </select>
                    <div v-if="topicsSet.size >= 1" class="PCJ-topics-help-text">
                      Select at least 1 topic, up to 3. Pre-defined topics cannot be deselected
                    </div>
                    <!-- <option selected disabled style="background-color:lightblue">Biochemistry</option> -->
                  </div>
                  <!--<div v-if="article_data.is_staff && isPCJ" class="sc-form-row">-->
                  <div v-if="isPCJ" class="sc-form-row">
                    <div class="se-label">Conference</div>
                    <select v-model="article_data.conference" id="conference" class="sc-text-input se-editor">
                      <option value="">None</option>
                      <option value="Euring 2023">Euring 2023</option>
                      <option value="JOBIM">JOBIM</option>
                      <option value="CAA2025">CAA2025</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isPCJ && is_topics_checkbox_mandatory" class="form-check" id="mandatoryCheckbox">
              <input v-model="is_single_topic_override" @change="checkArticleValidity" true-value=true false-value=false
                class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
              <label v-if="topicsSet.size == 1" class="form-check-label" for="flexCheckDefault">
                You have selected only one topic. Please tick this box if you prefer to keep only one topic. If not,
                please select one or two additional topics.
              </label>
              <label v-if="topicsSet.size == 0" class="form-check-label" for="flexCheckDefault">
                You haven't selected any topic. Please tick this box if you prefer to keep no topic. If not, please
                select one or two additional topics.
              </label>
            </div>

            <div id="section-title" v-bind:class="{ 'with-anchor': isTrad }">
              <div v-if="languageCode == 'en'">
                <div class="article-heading" id="section-title"><span>Title</span></div>
                <div v-if="isTrad" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <ckeditor read-only="true" :config="editorTitleConfig" v-model="title_text" id="title"
                      ref="title_ckeditor"></ckeditor>
                    <div id="title-text" class="d-none" v-html="title_text"></div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div v-if="is_title_already_translated" class="info-not-editable">The title was already translated
                      in the original article</div>
                    <ckeditor v-if="is_title_already_translated" read-only="true" :config="editorTransTitleConfig"
                      v-model="transtitle_text" id="transtitle" ref="transTitleCkeditor"></ckeditor>
                    <ckeditor v-else-if="!is_editable" read-only="true" :config="editorTransTitleConfig"
                      v-model="trans_article.title_tex" id="transtitle" ref="transTitleCkeditor"></ckeditor>
                    <ckeditor v-else :config="editorTransTitleConfig" @ready="onEditorReady"
                      v-model="trans_article.title_tex" id="transtitle" ref="transTitleCkeditor" @drop.stop.prevent>
                    </ckeditor>
                    <div id="transtitle-text" class="d-none" v-html="transtitle_text"></div>
                  </div>
                </div>
                <div v-else class="col-9">
                  <div v-if="title_text || isPCJ" class="col-9">
                    <ckeditor :config="editorTitleConfig" v-model="title_text" id="title" ref="title_ckeditor">
                    </ckeditor>
                    <div id="title-text" class="d-none" v-html="title_text"></div>
                  </div>
                  <div v-if="article_data.trans_title_tex">
                    <div class="article-heading">Title translation ({{ article_data.trans_lang }})</div>
                    <ckeditor :config="editorTransTitleConfig" v-model="transtitle_text" id="transtitle"
                      ref="transTitleCkeditor"></ckeditor>
                    <div id="transtitle-text" class="d-none" v-html="transtitle_text"></div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="article-heading" id="section-title"><span>Titre</span></div>
                <div v-if="isTrad" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <ckeditor read-only="true" :config="editorTitleConfig" v-model="title_text" id="title"
                      ref="title_ckeditor"></ckeditor>
                    <div id="title-text" class="d-none" v-html="title_text"></div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div v-if="is_title_already_translated" class="info-not-editable">Une traduction du titre est déjà
                      disponible dans l'article original</div>
                    <ckeditor v-if="is_title_already_translated" read-only="true" :config="editorTransTitleConfig"
                      v-model="transtitle_text" id="transtitle" ref="transTitleCkeditor"></ckeditor>
                    <ckeditor v-else-if="!is_editable" read-only="true" :config="editorTransTitleConfig"
                      v-model="trans_article.title_tex" id="transtitle" ref="transTitleCkeditor"></ckeditor>
                    <ckeditor v-else :config="editorTransTitleConfig" @ready="onEditorReady"
                      v-model="trans_article.title_tex" id="transtitle" ref="transTitleCkeditor" @drop.stop.prevent>
                    </ckeditor>
                    <div id="transtitle-text" class="d-none" v-html="transtitle_text"></div>
                  </div>
                </div>
                <div v-else class="col-9">
                  <div v-if="title_text || isPCJ" class="col-9">
                    <ckeditor :config="editorTitleConfig" v-model="title_text" id="title" ref="title_ckeditor">
                    </ckeditor>
                    <div id="title-text" class="d-none" v-html="title_text"></div>
                  </div>
                  <div v-if="article_data.trans_title_tex">
                    <div class="article-heading">Title translation ({{ article_data.trans_lang }})</div>
                    <ckeditor :config="editorTransTitleConfig" v-model="transtitle_text" id="transtitle"
                      ref="transTitleCkeditor"></ckeditor>
                    <div id="transtitle-text" class="d-none" v-html="transtitle_text"></div>
                  </div>
                </div>
              </div>

              <!-- <div v-if="isTrad" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <ckeditor read-only="true" :config="editorTitleConfig" v-model="title_text" id="title" ref="title_ckeditor"></ckeditor>
                <div id="title-text" class="d-none" v-html="title_text"></div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                <div v-if="is_title_already_translated" class="info-not-editable">The title was already translated in the original article</div>
                <ckeditor v-if="is_title_already_translated" read-only="true" :config="editorTransTitleConfig" v-model="transtitle_text" id="transtitle" ref="transTitleCkeditor"></ckeditor>
                <ckeditor v-else-if="!is_editable" read-only="true" :config="editorTransTitleConfig" v-model="trans_article.title_tex" id="transtitle" ref="transTitleCkeditor"></ckeditor>
                <ckeditor v-else :config="editorTransTitleConfig" @ready="onEditorReady" v-model="trans_article.title_tex" id="transtitle" ref="transTitleCkeditor" @drop.stop.prevent></ckeditor>
                <div id="transtitle-text" class="d-none" v-html="transtitle_text"></div>
              </div>
            </div>
            <div v-else class="col-9">
              <div v-if="title_text || isPCJ" class="col-9">
                <ckeditor :config="editorTitleConfig" v-model.lazy="title_text" id="title" ref="title_ckeditor"></ckeditor>
                <div id="title-text" class="d-none" v-html="title_text"></div>
              </div>
              <div v-if="article_data.trans_title_tex">
                <div class="article-heading">Title translation ({{ article_data.trans_lang }})</div>
                <ckeditor :config="editorTransTitleConfig" v-model="transtitle_text" id="transtitle" ref="transTitleCkeditor"></ckeditor>
                <div id="transtitle-text" class="d-none" v-html="transtitle_text"></div>
              </div>
            </div>-->
            </div>
          </div>

          <div v-if="!isTrad && !isPCJ" style="max-width:800px">
            <div class="article-heading" id="section-files"><span>Files</span></div>
            <div class="sc-card">
              <div class="se-label">Image</div>
              <input class="" type="file" @change="handleIconFileSelect" id="icon-file-input">
              <div class="file-preview" v-if="iconFilePreview">
                <img v-if="isImage(selectedIconFile)" :src="iconFilePreview" alt="File Preview" />
                <span v-else-if="iconFilePreview.name">{{ iconFilePreview.name }}</span>
                <img v-else :src="iconFilePreview" />
              </div>
              <div class="se-footer">
                <div class="float-end">
                  <button class="btn btn-outline-secondary btn-sm" v-on:click="delete_icon_file()"><i
                      class="bi bi-trash"></i></button>
                </div>
              </div>
            </div>
          </div>

          <!--  Authors section  -->
          <div class="col-9">
            <div v-if="article_data.contributors && article_data.contributors.length && !isTrad" id="section-contribs">
              <div class="article-heading"><span>Authors</span></div>
              <div v-for="(contrib, index) in article_data.contributors" v-bind:key="contrib.contrib_xml"
                class="sc-card" v-bind:id="'section-contribs-' + index">
                <div class="se-label">Person</div>
                <div class="sc-default-model">
                  <div class="ref-type">
                    <div class="float-end">
                      <button v-if="index > 0" class="btn btn-outline-secondary btn-sm"
                        v-on:click="moveAuthor(index, -1)"><i class="bi bi-arrow-up"></i></button>
                      <button v-if="index < article_data.contributors - 1" class="btn btn-outline-secondary btn-sm"
                        v-on:click="moveAuthor(index, 1)"><i class="bi bi-arrow-down"></i></button>
                    </div>
                    <div class="se-header">{{ stringName(contrib.first_name, contrib.last_name) }}</div>
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">First name</div>
                    <input type="text" class="sc-text-input se-editor" v-model="contrib.first_name" />
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">Last name</div>
                    <input type="text" class="sc-text-input se-editor" v-model="contrib.last_name" />
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">Corresponding Author</div>
                    <input class="styled" type="checkbox" v-model="contrib.corresponding" />
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">Email</div>
                    <input type="email" class="sc-text-input se-editor" v-model="contrib.email" />
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">
                      Affiliation
                      <span
                        title="Several affiliations can be declared. Each affiliation must be reported on a single line and the different affiliations must be reported on different lines"><i
                          class="bi bi-question-circle text-primary fs-6"></i></span>
                    </div>
                    <textarea class="sc-textarea-input" v-model="contrib.address_text"></textarea>
                  </div>
                  <div class="sc-form-row" v-bind:class="[contrib.is_author_orcid_invalid ? 'invalid-field' : '']">
                    <div class="se-label">ORCID</div>
                    <input type="text" class="sc-text-input se-editor" pattern="\w{4}-\w{4}-\w{4}-\w{4}"
                      placeholder="0000-0000-0000-0000" @paste="handleOrcidInputPaste($event, contrib)"
                      v-model="contrib.orcid" />
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">Equal contrib</div>
                    <input class="styled" type="checkbox" v-model="contrib.equal_contrib" />
                  </div>
                  <!-- <div class="sc-form-row">
                  <div class="se-label">Deceased (non-mandatory declaration)</div>
                  <input class="styled" type="checkbox" v-model="contrib.deceased_before_publication">
                </div> -->
                  <!--  <div class="collapse" v-bind:id="'author-more-' + index">-->
                  <!--  <div class="sc-form-row">-->
                  <!--  <div class="se-label">Prefix</div>-->
                  <!--  <input type="text" class="sc-text-input se-editor" v-model="contrib.prefix">-->
                  <!--  </div>-->
                  <!--  <div class="sc-form-row">-->
                  <!--  <div class="se-label">Suffix</div>-->
                  <!--  <input type="text" class="sc-text-input se-editor" v-model="contrib.suffix">-->
                  <!--  </div>-->
                  <!--  </div>-->
                  <div class="se-footer">
                    <div>
                      <!--  <a data-bs-toggle="collapse" v-bind:href="'#author-more-' + index"-->
                      <!--   v-on:click="toggleMoreAuthorFieldsText(index)" ref="more_fields" class="more-fields">-->
                      <!--  <i class="bi bi-chevron-down"></i> More fields-->
                      <!--  </a>-->
                    </div>
                    <div class="float-end">
                      <button href="#deletePersonModal" class="btn btn-outline-secondary btn-sm" data-bs-toggle="modal"
                        v-on:click="sendInfo(index)"><i class="bi bi-trash"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sc-plus">
                <button class="btn btn-outline-secondary" v-on:click="insert_author()">Add an author</button>
              </div>
            </div>
          </div>

          <!--  Abstract section  -->
          <div v-if="isTrad">
            <div v-if="languageCode == 'en'">
              <div v-if="abstract_text" class="article-heading">Abstract</div>
              <div v-if="abstract_text" id="section-abstracts" class="row" v-bind:class="{ 'with-anchor': isTrad }">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <ckeditor :config="editorAbstractConfig" v-model="abstract_text" id="abstract"></ckeditor>
                  <div id="abstract-text" class="d-none" v-html="abstract_text"></div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div v-if="is_abstract_already_translated" class="info-not-editable">The abstract was already
                    translated in the original article</div>
                  <ckeditor v-if="is_abstract_already_translated" :config="editorAbstractConfig"
                    v-model="transabstract_text" id="trans_abstract_text"></ckeditor>
                  <ckeditor v-else-if="!is_editable" :config="editorAbstractConfig" v-model="transabstract_text"
                    id="trans_abstract_text"></ckeditor>
                  <ckeditor v-else :config="editorTransAbstractConfig" @ready="onEditorReady"
                    v-model="trans_abstract_text" id="trans_abstract_text"></ckeditor>
                  <div id="trans_abstract_text-text" class="d-none" v-html="trans_abstract_text"></div>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="abstract_text" class="article-heading">Résumé</div>
              <div v-if="abstract_text" id="section-abstracts" class="row" v-bind:class="{ 'with-anchor': isTrad }">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <ckeditor :config="editorAbstractConfig" v-model="abstract_text" id="abstract"></ckeditor>
                  <div id="abstract-text" class="d-none" v-html="abstract_text"></div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div v-if="is_abstract_already_translated" class="info-not-editable">Une traduction du résumé est déjà
                    disponible dans la version originale de l'article</div>
                  <ckeditor v-if="is_abstract_already_translated" :config="editorAbstractConfig"
                    v-model="transabstract_text" id="trans_abstract_text"></ckeditor>
                  <ckeditor v-else-if="!is_editable" :config="editorAbstractConfig" v-model="transabstract_text"
                    id="trans_abstract_text"></ckeditor>
                  <ckeditor v-else :config="editorTransAbstractConfig" @ready="onEditorReady"
                    v-model="trans_abstract_text" id="trans_abstract_text"></ckeditor>
                  <div id="trans_abstract_text-text" class="d-none" v-html="transabstract_text"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="article-heading">Abstract</div>
            <div id="section-abstracts" class="row">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <ckeditor :config="editorAbstractConfig" v-model="abstract_text" id="abstract"></ckeditor>
                <div id="abstract-text" class="d-none" v-html="abstract_text"></div>
              </div>
            </div>
          </div>
          <!--  Keywords section  -->
          <div v-if="isTrad">
            <div v-if="languageCode == 'en'">
              <div id="section-keywords" v-bind:class="{ 'with-anchor': isTrad }">
                <div v-if="kwds_text" class="article-heading">Keywords</div>
                <div v-if="kwds_text" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <textarea disabled id="keywords" class="sc-textarea-input" v-model="kwds_text"></textarea>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div v-if="is_kwd_already_translated" class="info-not-editable">The keywords were already translated
                      in the original article</div>
                    <textarea disabled v-if="is_kwd_already_translated || !is_editable" id="trans-keywords"
                      class="sc-textarea-input" v-model="trans_kwds_text" placeholder="Translate keywords"></textarea>
                    <textarea v-else id="trans-keywords" class="sc-textarea-input" v-model="trans_kwds_text"
                      placeholder="Translate keywords"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div id="section-keywords" v-bind:class="{ 'with-anchor': isTrad }">
                <div v-if="kwds_text" class="article-heading">Mots clés</div>
                <div v-if="kwds_text" class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <textarea disabled id="keywords" class="sc-textarea-input" v-model="kwds_text"></textarea>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <div v-if="is_kwd_already_translated" class="info-not-editable">Une traduction des mots clés est
                      déjà disponbible dans la version originale de l'article</div>
                    <textarea disabled v-if="is_kwd_already_translated || !is_editable" id="trans-keywords"
                      class="sc-textarea-input" v-model="trans_kwds_text" placeholder="Translate keywords"></textarea>
                    <textarea v-else id="trans-keywords" class="sc-textarea-input" v-model="trans_kwds_text"
                      placeholder="Translate keywords"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div v-else-if="article_data.abstracts && article_data.abstracts.length" id="section-abstracts">

            <div id="section-keywords" class="with-delete">
              <div class="article-heading">Keywords</div>
              <textarea id="keywords" class="sc-textarea-input sc-textarea-input-tall" v-model="kwds_text"></textarea>
            </div>
          </div>

          <!--  Subject section  -->
          <div class="col-9">
            <div v-if="article_data.subjs && article_data.subjs.length && !isTrad && !isPCJ" id="section-subjs"
              class="with-delete">
              <div class="article-heading"><span>Subjects</span></div>
              <div v-for="(subj, index) in article_data.subjs" v-bind:key="subj.seq" class="sc-card"
                v-bind:id="'section-subjs-' + index">
                <div class="se-label">Subject</div>
                <div class="sc-default-model">
                  <div class="sc-form-row">
                    <div class="se-label">Language</div>
                    <select class="sc-text-input se-editor" name="subj_lang" v-model="subj.lang">
                      <option value="en">English</option>
                      <option value="fr">French</option>
                    </select>
                  </div>
                  <div class="sc-form-row">
                    <div class="se-label">Value</div>
                    <input type="text" class="sc-text-input se-editor" v-model="subj.value" />
                  </div>
                  <div class="se-footer">
                    <div class="float-end">
                      <button class="btn btn-outline-secondary btn-sm"
                        v-on:click="delete_field(article_data.subjs, index)"><i class="bi bi-trash"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sc-plus">
                <button class="btn btn-outline-secondary" v-on:click="insert_subj()">Add a subject in another
                  language</button>
              </div>
            </div>
          </div>

          <!--  Full text section  -->
          <div v-if="isTrad">
            <div v-if="languageCode == 'en'">
              <div class="article-heading">Full text</div>
              <div id="section-fulltext" class="row" v-bind:class="{ 'with-anchor': isTrad }">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="synchronize_scrolling" id="synchScroll" />
                    <label class="form-check-label" for="synchScroll"> Synchronize scrolling </label>
                  </div>
                  <div id="fulltext-zone" v-html="article_data.body_html"></div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <ckeditor v-if="is_editable" :id="editor - fulltext" :config="full_editorConfig"
                    v-model="trans_body_html" id="transFullTextCked" ref="editorFullText"
                    @ready="onFullTextEditorReady"></ckeditor>
                  <ckeditor v-else :config="full_editorConfig" read-only="true" v-model="trans_body_html"
                    id="transFullTextCked" ref="editorFullText" @ready="onFullTextEditorReady"></ckeditor>
                  <div id="trans_full_text-text" class="d-none" v-html="trans_article.body_html"></div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="article-heading">Texte intégral</div>
              <div id="section-fulltext" class="row" v-bind:class="{ 'with-anchor': isTrad }">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="synchronize_scrolling" id="synchScroll" />
                    <label class="form-check-label" for="synchScroll"> Synchroniser le défilement </label>
                  </div>
                  <div id="fulltext-zone" v-html="article_data.body_html"></div>
                </div>

                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <ckeditor v-if="is_editable" :id="editor - fulltext" :config="full_editorConfig"
                    v-model="trans_body_html" id="transFullTextCked" ref="editorFullText"
                    @ready="onFullTextEditorReady"></ckeditor>
                  <ckeditor v-else :config="full_editorConfig" read-only="true" v-model="trans_body_html"
                    id="transFullTextCked" ref="editorFullText" @ready="onFullTextEditorReady"></ckeditor>
                  <div id="trans_full_text-text" class="d-none" v-html="trans_article.body_html"></div>
                </div>
              </div>
            </div>
          </div>



          <!--  References section  -->
          <div v-if="!article_data.is_staff || !article_data.bibitems.length" class="mt-3"></div>
          <div v-if="article_data.is_staff && article_data.bibitems && isPCJ" id="section-bibitems">
            <div class="article-heading" v-bind:class="{ row: isPCJ }">
              <div class="col-sm">References</div>
              <div v-if="isPCJ" class="col-sm ms-3">
                <button class="btn btn-outline-secondary btn-space" v-on:click="sortRef()" title="Sort references"><i
                    class="bi bi-sort-alpha-down"></i></button>
                <label class="btn btn-outline-secondary btn-space" title="Fill references from a BibTeX file">Bibtex
                  <input name="bibtex-ref" type="file" hidden @change="getBibTexRef" accept=".bib" /><i
                    class="bi bi-upload"></i>
                </label>
                <label class="btn btn-outline-secondary btn-space"
                  title="Fill references from a file with a list of DOIs">DOIs
                  <input name="doi-ref" type="file" hidden @change="getBibTexRef" accept=".txt" /><i
                    class="bi bi-upload"></i>
                </label>
                <button href="#deleteAllRefModal" class="btn btn-outline-secondary btn-space" data-bs-toggle="modal"
                  title="Delete all references">
                  <i class="bi bi-trash"></i>
                </button>
                <div id="spinner-doi-ref" class="spinner-border spinner-border-sm" role="status"
                  style="visibility: hidden"></div>
                <span id="id-getrefs-text"></span>
              </div>
              <div v-else class="col-sm ms-3">
                <input class="styled" type="checkbox" v-model="article_data.bibitems_with_ordered_label" />
                <label class="se-ref-header-label">Use position as label</label>
              </div>
            </div>
            <div class="ref-preview">
              <splitpanes class="default-theme">
                <pane min-size="20" :size="40">
                  <div id="ref-preview-left">
                    <div v-if="ref && article_data.bibitems.length" class="sc-card sc-card-ref"
                      v-bind:class="[ref.type == 'unknown' ? 'ref-unknown' : '']"
                      v-bind:id="'section-bibitems-' + ref_index">
                      <span>
                        <button :disabled="ref_index <= 0" class="btn-sm btn-light btn-space" v-on:click="prev()">
                          <i class="bi bi-dash-lg"></i>
                        </button>
                        <input type="number" v-on:change="updateIndex" :value.number="ref_index + 1" min="1"
                          :max="article_data.bibitems.length" />
                        <button :disabled="ref_index >= article_data.bibitems.length - 1"
                          class="btn-sm btn-light btn-space" v-on:click="next()">
                          <i class="bi bi-plus-lg"></i>
                        </button>
                      </span>

                      <div class="ref-type">
                        <div class="float-end">
                          <span v-if="ref.type == 'unknown'" style="margin-right: 10px">Change reference type <i
                              class="bi bi-arrow-right"></i> </span>
                          <button class="btn btn-sm btn-space"
                            v-bind:class="[ref.type == 'unknown' ? 'btn-danger' : 'btn-outline-secondary']"
                            v-on:click="setChangeRef(true)" data-bs-toggle="modal" data-bs-target="#referenceModal"
                            title="Change reference type">
                            <i class="bi bi-scissors"></i>
                          </button>
                          <button class="btn btn-outline-secondary btn-sm btn-space" v-on:click="setChangeRef(false)"
                            data-bs-toggle="modal" data-bs-target="#referenceModal" title="Create new reference">
                            <i class="bi bi-plus-lg"></i>
                          </button>
                          <button href="#deleteRefModal" class="btn btn-outline-secondary btn-sm btn-space"
                            data-bs-toggle="modal" title="Delete this reference">
                            <i class="bi bi-trash"></i>
                          </button>
                          <button :disabled="ref_index <= 0" class="btn btn-outline-secondary btn-sm"
                            v-on:click="moveRef(-1)" title="Move this reference down">
                            <i class="bi bi-arrow-up"></i>
                          </button>
                          <button :disabled="ref_index >= article_data.bibitems.length - 1"
                            class="btn btn-outline-secondary btn-sm" v-on:click="moveRef(1)"
                            title="Move this reference up">
                            <i class="bi bi-arrow-down"></i>
                          </button>
                        </div>
                        <div class="se-label">{{ ref.type | capitalize }}</div>
                      </div>
                      <div class="ref-content">
                        <div>
                          <div class="float-end ms-3">
                            <button class="btn btn-outline-secondary btn-sm" v-on:click="fetchRefDoi(ref.doi)"
                              title="Get reference metadata from Crossref"><i class="bi bi-cloud-download"></i></button>
                          </div>
                          <div class="sc-form-row" v-bind:class="[ref.wrong_doi ? 'invalid-field' : '']">
                            <div class="se-label">DOI</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.doi" />
                          </div>
                        </div>
                        <div v-if="!article_data.bibitems_with_ordered_label" class="sc-form-row">
                          <div class="se-label">Label</div>
                          <input type="text" class="sc-text-input se-editor" v-model="ref.label" />
                        </div>
                        <div v-if="ref.type == 'unknown'" class="sc-form-row">
                          <div class="se-label">Text</div>
                          <textarea class="sc-textarea-input" v-model="ref.citation_tex"></textarea>
                        </div>
                        <div v-else-if="['article', 'misc'].some((n) => n === ref.type)" class="sc-form-row"
                          v-bind:class="[ref.is_bititem_title_missing ? 'invalid-field' : '']">
                          <div class="se-label">Title*</div>
                          <textarea class="sc-textarea-input" v-model="ref.article_title_tex"></textarea>
                        </div>
                        <div v-else-if="['book', 'phdthesis', 'proceedings'].some((n) => n === ref.type)"
                          class="sc-form-row" v-bind:class="[ref.is_bititem_title_missing ? 'invalid-field' : '']">
                          <div class="se-label">Title*</div>
                          <textarea class="sc-textarea-input" v-model="ref.source_tex"></textarea>
                        </div>
                        <div v-else-if="['incollection', 'inproceedings', 'inbook'].some((n) => n === ref.type)"
                          class="sc-form-row" v-bind:class="[ref.is_bititem_title_missing ? 'invalid-field' : '']">
                          <div class="se-label">Chapter Title*</div>
                          <textarea class="sc-textarea-input" v-model="ref.chapter_title_tex"></textarea>
                        </div>
                        <div v-else class="sc-form-row"
                          v-bind:class="[ref.is_bititem_title_missing ? 'invalid-field' : '']">
                          <div class="se-label">Title*</div>
                          <textarea class="sc-textarea-input" v-model="ref.title_tex"></textarea>
                        </div>
                        <div v-if="ref.type != 'unknown'">
                          <div class="sc-form-row"
                            v-bind:class="[ref.is_bibitem_author_missing ? 'invalid-field' : '']">
                            <div class="se-label">Authors*</div>
                            <textarea class="sc-textarea-input" v-model="ref.contribs_text"></textarea>
                          </div>
                          <div
                            v-if="['article', 'incollection', 'inproceedings', 'inbook', 'misc'].some((n) => n === ref.type)"
                            class="sc-form-row">
                            <div class="se-label">Source</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.source_tex" />
                          </div>
                          <div
                            v-if="['article', 'book', 'incollection', 'inproceedings', 'inbook', 'phdthesis', 'proceedings', 'misc'].some((n) => n === ref.type)"
                            class="sc-form-row">
                            <div class="se-label">Series</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.series" />
                          </div>
                          <div
                            v-if="['article', 'book', 'incollection', 'inproceedings', 'inbook', 'phdthesis', 'proceedings', 'misc'].some((n) => n === ref.type)"
                            class="sc-form-row" v-bind:class="[ref.is_volume_over_max_length ? 'invalid-field' : '']">
                            <div class="se-label">Volume</div>
                            <input type="text" class="sc-text-input se-editor" maxlength="32" v-model="ref.volume" />
                          </div>
                          <div
                            v-if="['article', 'book', 'incollection', 'inproceedings', 'inbook', 'phdthesis', 'proceedings', 'misc'].some((n) => n === ref.type)"
                            class="sc-form-row">
                            <div class="se-label">Number</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.issue" />
                          </div>
                          <div
                            v-if="['book', 'incollection', 'inproceedings', 'inbook', 'phdthesis', 'proceedings'].some((n) => n === ref.type)"
                            class="sc-form-row">
                            <div class="se-label">Publisher Name</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.publisher_name" />
                          </div>
                          <div
                            v-if="['book', 'incollection', 'inproceedings', 'inbook', 'phdthesis', 'proceedings'].some((n) => n === ref.type)"
                            class="sc-form-row">
                            <div class="se-label">Publisher Location</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.publisher_loc" />
                          </div>
                          <div class="sc-form-row" v-bind:class="[ref.is_bibitem_year_missing ? 'invalid-field' : '']">
                            <div class="se-label">Year*</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.year" />
                          </div>
                          <div
                            v-if="['article', 'incollection', 'inproceedings', 'inbook', 'phdthesis', 'proceedings', 'misc'].some((n) => n === ref.type)"
                            class="sc-form-row">
                            <div class="se-label">First Page</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.fpage" />
                          </div>
                          <div
                            v-if="['article', 'incollection', 'inproceedings', 'inbook', 'phdthesis', 'proceedings', 'misc'].some((n) => n === ref.type)"
                            class="sc-form-row">
                            <div class="se-label">Last Page</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.lpage" />
                          </div>
                          <div v-if="['article', 'misc'].some((n) => n === ref.type)" class="sc-form-row">
                            <div class="se-label">Page Range</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.page_range" />
                          </div>
                          <div v-if="ref.type == 'book' || ref.type == 'phdthesis'" class="sc-form-row">
                            <div class="se-label">Page Count</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.size" />
                          </div>
                          <div v-if="['article', 'misc'].some((n) => n === ref.type)" class="sc-form-row">
                            <div class="se-label">Article Id</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.eid" />
                          </div>
                          <div class="sc-form-row">
                            <div class="se-label">Comment</div>
                            <input type="text" class="sc-text-input se-editor" v-model="ref.comment" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </pane>
                <pane min-size="20">
                  <div id="ref-preview-right">
                    <ul class="no-bullets">
                      <li class="bib-list" v-for="(item, index) in article_data.bibitems">
                        <a v-bind:class="[index == ref_index ? 'ref-selected' : 'ref-unselected']"
                          :href="'#' + 'section-bibitems-' + index" :id="'ref-' + index" v-on:click="go(index)"><span
                            v-if="article_data.bibitems_with_ordered_label">[{{ index + 1 }}]</span><span v-else>{{
                              item.label }}</span> <span v-html="citation(item)"></span></a>
                      </li>
                    </ul>
                  </div>
                </pane>
              </splitpanes>
            </div>
          </div>

          <div v-if="isTrad && !isTranslatedArticleComplete()">
            <div v-if="languageCode == 'en'">
              <div id="info_to_fill" class="alert alert-info col-xs-12 col-md-6 offset-6">
                <p>Your article is not yet ready for submission. Please fill in the following information:</p>
                <ul>
                  <li v-if="!areTranslatorsComplete()">First name, last name and email of the translator(s)</li>
                  <li v-if="!is_title_already_translated && !trans_article.title_tex.length">Translated title</li>
                  <li v-if="!is_abstract_already_translated && !trans_abstract_text.length">Translated abstract</li>
                  <li v-if="!is_kwd_already_translated && kwds_text.length && !trans_kwds_text.length">Translated
                    keywords</li>
                  <li v-if="trans_body_html == getCssText()">Translated full text</li>
                </ul>
              </div>
              <p class="text-end"><button class="btn btn-lg btn-success disabled">Next</button></p>
            </div>
            <div v-else>
              <div id="info_to_fill" class="alert alert-info col-xs-12 col-md-6 offset-6">
                <p>Votre article n'est pas encore prêt pour la soumission. Veuillez renseigner les informations
                  suivantes :</p>
                <ul>
                  <li v-if="!areTranslatorsComplete()">Prénom, nom et adresse mail du/des tranducteur(s)</li>
                  <li v-if="!is_title_already_translated && !trans_article.title_tex.length">La traduction du titre</li>
                  <li v-if="!is_abstract_already_translated && !trans_abstract_text.length">La traduction du résumé</li>
                  <li v-if="!is_kwd_already_translated && kwds_text.length && !trans_kwds_text.length">La traduction des
                    mots clés</li>
                  <li v-if="trans_body_html == getCssText()">La traduction du texte de l'article</li>
                </ul>
              </div>
              <p class="text-end"><button class="btn btn-lg btn-success disabled">Suivant</button></p>
            </div>
          </div>
          <div v-else-if="isTrad && is_editable">
            <div v-if="languageCode == 'en'" class="mt-5">
              <p class="text-end"><button class="btn btn-lg btn-success" v-on:click="saveForm(true)">Next</button></p>
            </div>
            <div v-else class="mt-5">
              <p class="text-end"><button class="btn btn-lg btn-success" v-on:click="saveForm(true)">Suivant</button>
              </p>
            </div>


          </div>
        </div>
      </div>
    </form>

    <div class="modal fade" id="referenceModal" tabindex="-1" aria-labelledby="referenceModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="referenceModalLabel">{{ modal_title }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p v-if="article_data.bibitems && !change_ref"><label>Position</label> <input type="number"
                v-model.number="modal_ref_index" min="1" :max="article_data.bibitems.length + 1" style="width: 100px" />
            </p>
            <p class="text-center"><button type="button" class="btn btn-outline-secondary"
                v-on:click="insertRefOrChangeRefType('article')" data-bs-dismiss="modal">Article</button></p>
            <p class="text-center"><button type="button" class="btn btn-outline-secondary"
                v-on:click="insertRefOrChangeRefType('book')" data-bs-dismiss="modal">Book</button></p>
            <p class="text-center"><button type="button" class="btn btn-outline-secondary"
                v-on:click="insertRefOrChangeRefType('inbook')" data-bs-dismiss="modal">Chapter</button></p>
            <p class="text-center"><button type="button" class="btn btn-outline-secondary"
                v-on:click="insertRefOrChangeRefType('phdthesis')" data-bs-dismiss="modal">Thesis</button></p>
            <p class="text-center"><button type="button" class="btn btn-outline-secondary"
                v-on:click="insertRefOrChangeRefType('misc')" data-bs-dismiss="modal">Misc</button></p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteAllRefModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmation</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete ALL references?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
              v-on:click="delete_all_bibitems()">Delete</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteRefModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmation</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this reference?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
              v-on:click="delete_bibitem(article_data.bibitems)">Delete</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deletePersonModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Confirmation </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to delete this person?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
            <button v-if="isTrad" type="button" class="btn btn-danger" data-bs-dismiss="modal"
              v-on:click="delete_field(trans_article.contributors, author_index)">Delete</button>
            <button v-else type="button" class="btn btn-danger" data-bs-dismiss="modal"
              v-on:click="delete_field(article_data.contributors, author_index)">Delete</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CKEditor from "ckeditor4-vue";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

// axios.defaults.withCredentials = true
axios.defaults.baseURL = window.location.origin + "/";
if (window.location.hostname == "editor-test.centre-mersenne.org" || window.location.hostname == "pcj-test.centre-mersenne.org" || window.location.hostname == "peercommunityjournal.org") {
  axios.defaults.baseURL += "submit/";
}
// else {
//  axios.defaults.baseURL = 'http://127.0.0.1:8104/';
//  axios.defaults.baseURL = '/';
// }
function getML(article_data, id) {
  MathJax.startup.promise.then(() => {
    let input = document.getElementById(id);
    if (input === null) {
      return;
    }

    let output = document.createElement("div");
    output.appendChild(document.createTextNode(input.textContent));
    MathJax.typesetPromise([output]);

    let result = [];
    let nodeList = output.childNodes;
    for (var i = 0; i < nodeList.length; ++i) {
      let node = nodeList[i];
      if (node.tagName == "MJX-CONTAINER") {
        let value = node.getElementsByTagName("math")[0].outerHTML;
        result.push(value);
      }
    }

    if (id == "abstract-text") {
      article_data.abstract_formulas = result;

    } else if (id == "title-text") {
      article_data.title_formulas = result;
    } else if (id == "transabstract-text") {
      article_data.trans_abstract_formulas = result;
    } else if (id == "transtitle-text") {
      article_data.trans_title_formulas = result;
    }
  });
}

function scrollToElt(id_name) {
  function scroll() {
    var el = document.getElementById(id_name);
    if (el) {
      const scroll_props = {
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      };
      if (el.parentElement.className == "bib-list") {
        var rectElem = el.getBoundingClientRect();
        var container = document.getElementById("ref-preview-right");
        var rectContainer = container.getBoundingClientRect();
        if (rectElem.bottom > rectContainer.bottom || rectElem.top < rectContainer.top) {
          el.scrollIntoView(scroll_props);
        }
      } else {
        el.scrollIntoView(scroll_props);
      }
    }
  }
  setTimeout(scroll, 200);
}

var all_types = {
  "biographical-note": "Biographical note",
  "letter": "Comment & Reply",
  "corrigendum": "Corrigendum",
  "editorial": "Editorial",
  "erratum": "Erratum",
  "expression-of-concern": "Expression of Concern",
  "foreword": "Foreword",
  "guest-editors": "Guest editors",
  "historical-commentary": "Historical Commentary",
  "history-of-sciences": "History of Sciences and Ideas",
  "congress": "Intervention in a conference",
  "news": "News and views",
  "opinion": "Opinion, perspective",
  "preliminary-communication": "Preliminary communication",
  "research-article": "Research article",
  "retraction": "Retraction of Publication",
  "review": "Review article",
  "software-tool": "Software tool"
}

var all_topics = [
  {
    "discipline": "Biology",
    "topics": [
      "Agricultural sciences",
      "Applied biological sciences",
      "Archaeology",
      "Biochemistry",
      "Biology of interactions",
      "Biophysics and computational biology",
      "Cell biology",
      "Developmental biology",
      "Ecology",
      "Environmental sciences",
      "Evolution",
      "Genetics/genomics",
      "Immunology and inflammation",
      "Microbiology",
      "Paleontology",
      "Pharmacology",
      "Physiology",
      "Plant biology",
      "Population biology",
      "Sustainability science",
      "Systems biology",
    ]
  },
  {
    "discipline": "Chemistry",
    "topics": [
      "Agricultural sciences",
      "Biochemistry",
      "Chemistry",
      "Ecology",
    ]
  },
  {
    "discipline": "Computer sciences",
    "topics": [
      "Biophysics and computational biology",
      "Computer sciences",
    ]
  },
  {
    "discipline": "Earth sciences",
    "topics": [
      "Earth, atmospheric, and planetary sciences",
      "Ecology",
      "Environmental sciences",
      "Paleontology",
      "Sustainability science",
    ]
  },
  {
    "discipline": "Engineering",
    "topics": [
      "Agricultural sciences",
      "Ecology",
      "Engineering",
    ]
  },
  {
    "discipline": "Humanities and social sciences",
    "topics": [
      "Agricultural sciences",
      "Anthropology",
      "Archaeology",
      "Business and Management",
      "Demography",
      "Economic sciences",
      "Geography",
      "History",
      "Literature",
      "Philosophy",
      "Political sciences",
      "Psychological and cognitive sciences",
      "Sociology",
    ]
  },
  {
    "discipline": "Mathematics",
    "topics": [
      "Applied mathematics",
      "Mathematics",
      "Statistics",
    ]
  },
  {
    "discipline": "Medical sciences",
    "topics": [
      "Genetics/genomics",
      "Health sciences",
      "Immunology and inflammation",
      "Medical sciences",
      "Neuroscience",
      "Pharmacology",
      "Physiology",
      "Psychological and cognitive sciences",
    ]
  },
  {
    "discipline": "Physics",
    "topics": [
      "Applied physical sciences",
      "Astronomy",
      "Biophysics and computational biology",
      "Earth, atmospheric, and planetary sciences",
      "Physics",
    ]
  }
]

var mandatory_topics = {
  "ecology": "Ecology",
  "evolbiol": "Evolution",
  "genomics": "Genetics/genomics",
  "paleo": "Paleontology",
  "archaeo": "Archaeology",
  "microbiol": "Microbiology",
  "neuro": "Neuroscience"
}

export default {
  name: "Article",
  components: {
    ckeditor: CKEditor.component,
    Splitpanes,
    Pane,
  },
  data() {
    return {
      article_data: {},
      abstract_text: "",
      transabstract_text: "",
      title_text: "",
      transtitle_text: "",
      doi: "",
      colid: "",
      ref: "",
      ref_index: 0,
      modal_ref_index: 1,
      modal_title: "",
      change_ref: false,
      bibtex: "",
      editorAbstractConfig: {
        removeButtons: "",
        toolbar: [
          ["Bold", "Italic", "Subscript", "Superscript"],
          ["BulletedList", "NumberedList"],
          ["Link", "Unlink"],
          ["Mathjax"],
        ],
        extraPlugins: "mathjax",
        mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/latest.js?config=TeX-AMS_HTML",
        mathJaxClass: "mathjax-formula",
        shiftEnterMode: CKEditor.ENTER_P,
        fillEmptyBlocks: false,
        versionCheck: false,
      },
      editorTransAbstractConfig: {
        removeButtons: "",
        toolbar: [
          ["Bold", "Italic", "Subscript", "Superscript"],
          ["BulletedList", "NumberedList"],
          ["Link", "Unlink"],
          ["Mathjax"],
        ],
        extraPlugins: "mathjax",
        mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/latest.js?config=TeX-AMS_HTML",
        mathJaxClass: "mathjax-formula",
        shiftEnterMode: CKEditor.ENTER_P,
        fillEmptyBlocks: false,
        versionCheck: false,
      },
      editorTitleConfig: {
        removeButtons: "",
        height: 60,
        toolbar: [
          ["Italic", "Subscript", "Superscript"],
          ["Mathjax"],
        ],
        extraPlugins: "mathjax",
        mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/latest.js?config=TeX-AMS_HTML",
        mathJaxClass: "mathjax-formula",
        removePlugins: "elementspath",
        resize_enabled: false,
        shiftEnterMode: CKEditor.ENTER_P,
        versionCheck: false,
      },
      editorTransTitleConfig: {
        removeButtons: "",
        height: 60,
        toolbar: [
          ["Italic", "Subscript", "Superscript"],
          ["Mathjax"],
        ],
        extraPlugins: "mathjax",
        mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/latest.js?config=TeX-AMS_HTML",
        mathJaxClass: "mathjax-formula",
        removePlugins: "elementspath",
        resize_enabled: false,
        shiftEnterMode: CKEditor.ENTER_P,
        versionCheck: false,
      },
      full_editorConfig: {
        removeButtons: "",
        height: 500,
        toolbar: [
          ["Bold", "Italic", "Subscript", "Superscript"],
          ["BulletedList", "NumberedList"],
          ["Link", "Unlink"],
          ["Mathjax", "Source"],
        ],
        allowedContent: true,
        forcePasteAsPlainText: true,
        extraAllowedContent: "div(*);span(*);em(*);figure(*);figcaption(*);p(*);sub(*);sup(*);section(*);img(*)",
        extraPlugins: "div,mathjax",
        mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/latest.js?config=TeX-AMS_HTML",
        mathJaxClass: "mathjax-formula",
        versionCheck: false,
      },
      base_url: axios.defaults.baseURL,
      trans_article: {
        unset: "unset",
      },
      translation_id: "",
      trans_abstract_text: "",
      is_abstract_already_translated: false,
      is_title_already_translated: false,
      is_kwd_already_translated: false,
      trans_lang: "",
      trans_body_html: "",
      kwds_text: "",
      trans_kwds_text: "",
      is_editable: true,
      author_index: null,
      selectedIconFile: null,
      iconFilePreview: null,
      all_types: all_types,
      all_topics: all_topics,
      topics: [],
      synchronize_scrolling: true,
      wto: "",
      languageCode: 'en',
      is_pcj_article_abstract_provided: false,
      is_pcj_title_article_provided: false,
      is_pcj_article_valid: true,
      is_pcj_article_keywords_provided: false,
      is_topics_checkbox_mandatory: false,
      is_single_topic_override: false,
      is_submission_dirty: false,
      is_topic_valid: false,
    };
  },
  created() {
    // It seems that with multiple ckeditor in the page, we need to delay the creation
    setTimeout(this.delayedCreated, 500);

  },
  computed: {
    isTrad() {
      return window.location.hostname == "trans-test.u-ga.fr" || location.href.includes("127.0.0.1:8105") || window.location.hostname == "translation.centre-mersenne.org" || location.href.includes("127.0.0.1:8000");
    },
    isPCJ() {
      return window.location.hostname == "editor-test.centre-mersenne.org" || window.location.hostname == "pcj-test.centre-mersenne.org" || window.location.hostname == "peercommunityjournal.org" || location.href.includes("127.0.0.1:8104");
    },
    submissionId() {
      if (this.isPCJ) {
        return window.submission_id
      }
    },
    PCJSubmissionURL() {
      if (this.submissionId) {
        if (window.is_staff) {
          // to redirect to Full Text tab
          return "/submit/article-edit-body/" + this.colid + "/" + this.doi
        }
        else {
          // to redirect to Finalize tab
          return "/submit/send-submission-request/" + this.submissionId
        }
      }
    },
    setTopicsMandatory() {
      if (this.topics.length <= 1) {
        this.is_topics_checkbox_mandatory = true
      } else {
        this.is_topics_checkbox_mandatory = false
      }
    },
    isTopicsCheckboxMandatory() {

      if (this.topics.length <= 1) {
        return true
      } else {
        return false
      }
    },
    topicsSet() {
      return new Set(this.topics)
    },
  },
  methods: {
    delayedCreated() {
      var uri = window.location.href;
      var list_ = uri.split("/");
      if (uri.slice(-1) == "/") {
        list_.pop();
      }
      if (list_.length > 3) {
        if (this.isTrad) {
          this.translation_id = list_.pop();
        }
        let suffix = list_.pop();
        this.doi = list_.pop() + "/" + suffix;
        this.colid = list_.pop();
      }
      uri = "api-article-edit/" + this.colid + "/" + this.doi + "/";
      if (this.isTrad) {
        uri = "api-article-edit/" + this.colid + "/" + this.doi + "/" + this.translation_id;
      }
      axios.get(uri).then((response) => {

        this.article_data = response.data;
        if (response.headers["content-language"] == "fr") {
          this.languageCode = "fr"
        } else if (response.headers["content-language"] == "en") {
          this.languageCode = "en"
        }
        for (let i = 0; i < this.article_data.bibitems.length; i++) {
          if (i == 0) {
            this.ref = this.article_data.bibitems[0];
          }
          this.checkRefDoi(i);
        }
        this.title_text = this.article_data.title_tex;
        this.transtitle_text = this.article_data.trans_title_tex;
        if (this.article_data["abstracts"].length > 0) {
          this.abstract_text = this.article_data.abstracts[0].value_tex;
        }
        if (this.article_data["abstracts"].length > 1) {
          this.transabstract_text = this.article_data.abstracts[1].value_tex;
        }

        this.iconFilePreview = this.article_data.icon_url;

        if (this.isTrad) {
          this.trans_lang = this.trans_article.lang;
          this.trans_article = this.article_data.translated_article;
          this.editorAbstractConfig.readOnly = true;

          this.trans_body_html = this.addCss(this.trans_article.body_html);

          if (!this.article_data["abstracts"].length) {
            this.is_abstract_already_translated = true;
          } else if (!this.article_data["abstracts"][0].value_tex.length) {
            this.is_abstract_already_translated = true;
          }

          for (let i = 0; i < this.article_data["abstracts"].length; i++) {
            if (this.article_data.abstracts[i].lang == this.trans_article.lang) {
              this.is_abstract_already_translated = true;
            }
          }
          if (!this.is_abstract_already_translated) {
            if (!this.trans_article["abstracts"].length) {
              this.trans_article["abstracts"] = [
                {
                  tag: "abstract",
                  lang: this.trans_article.lang,
                  value_html: "",
                  value_tex: "",
                },
              ];
            }
            this.trans_abstract_text = this.trans_article.abstracts[0].value_tex;
          }

          if (this.article_data.trans_lang == this.trans_article.lang && this.article_data.title_tex) {
            this.is_title_already_translated = true;
          }

          this.is_editable = this.trans_article.is_editable;
          this.prepare_kwds();
        }

        this.is_single_topic_override = this.article_data.is_single_topic_override;


        this.$nextTick(() => {
          // call selectpicker in nextTick so that the <select> is fully constructed in HTML
          // selectpicker can then apply the disabled options
          if (this.isPCJ) {
            this.prepare_kwds();
            this.topics = this.article_data.topics;
            this.checkTopics()
            this.checkArticleValidity()
            if (this.title_text) {
              this.is_pcj_title_article_provided = true
            } else {
              this.is_pcj_title_article_provided = false
            }
            if (this.abstract_text) {
              this.is_pcj_article_abstract_provided = true
            } else {
              this.is_pcj_article_abstract_provided = false
            }
            if (this.kwds_text) {
              this.is_pcj_article_keywords_provided = true
            } else {
              this.is_pcj_article_keywords_provided = false
            }
            if (!this.isTopicsCheckboxMandatory) {
              this.is_topic_valid = true
            } else if (this.is_single_topic_override == 'false' || this.is_single_topic_override == false) {
              this.is_topic_valid = false
            } else if (this.is_single_topic_override == 'true' || this.is_single_topic_override == true) {
              this.is_topic_valid = true
            }
            if (
              this.is_pcj_title_article_provided
              && this.is_pcj_article_abstract_provided
              && this.is_topic_valid
            ) {
              this.is_pcj_article_valid = true
            } else {
              this.is_pcj_article_valid = false
            }
            $("#article_topics").selectpicker('val', this.topics);

            $(document).ready(function () {
              $("#article_topics").selectpicker('val', this.topics);
            })


          }
          getML(this.article_data, "title-text");
          getML(this.article_data, "transtitle-text");
          getML(this.article_data, "abstract-text");
          getML(this.article_data, "transabstract-text");
          setTimeout(function () {
            var save_button = document.getElementById("id-save");
            this.is_submission_dirty = false
            save_button.classList.remove("btn-needs-save");
          }, 1000)
        });
      });
    },
    citation(ref) {
      var citation = "";
      var contribs = ref.contribs_text.split("\n");
      for (let i = 0; i < contribs.length; i++) {
        var author = contribs[i].split(",");
        citation += author.length > 0 ? author[0] : "";

        var first_name = author.length == 2 ? author[1].trim().split(" ") : [""];
        if (first_name && first_name[0]) {
          citation += ", " + first_name.map((s) => (s ? s[0] + "." : "")).join(" ");
        }
        citation += i != contribs.length - 1 ? "; " : "";
      }

      citation = citation.trim();
      if (citation) {
        citation = citation[citation.length - 1] == "." ? citation + " " : citation + ". ";
      }

      var title = "";
      if (ref.type == "article" || ref.type == "misc") {
        title = ref.article_title_tex;
      } else if (["incollection", "inproceedings", "inbook"].some((n) => n === ref.type)) {
        title = ref.chapter_title_tex;
      } else if (ref.type == "unknown") {
        title = ref.citation_tex;
        let i = title.indexOf(ref.label);
        if (i == 0) {
          title = title.slice(ref.label.length);
        }
      } else {
        title = ref.title_tex;
      }
      var publisher = [ref.publisher_name, ref.publisher_loc].filter(Boolean).join(", ");
      var part = ref.volume ? "<strong>" + " Volume " + ref.volume + "</strong>" : "";
      part += ref.year ? " (" + "<strong>" + ref.year + "</strong>" + ")" : "";
      part += ref.issue ? " no. " + "<strong>" + ref.issue + "</strong>" : "";
      var pages = ref.fpage ? "pp. " + "<strong>" + ref.fpage + "</strong>" : "";
      pages += ref.fpage && ref.lpage ? "-" + "<strong>" + ref.lpage + "</strong>" : "";
      citation += [title, ref.source_tex, ref.series, publisher, part, ref.eid, pages].filter(Boolean).join(", ");
      return citation;
    },
    updateIndex(event) {
      try {
        this.ref_index = event.target.value.trim() - 1;
        this.go(this.ref_index);
      } catch { }
    },
    next() {
      var pos = this.ref_index + 1;
      if (pos >= 0 && pos < this.article_data.bibitems.length) {
        this.ref_index++;
        this.ref = this.article_data.bibitems[pos];
        scrollToElt("ref-" + pos);
      }
    },
    prev() {
      var pos = this.ref_index - 1;
      if (pos >= 0 && pos < this.article_data.bibitems.length) {
        this.ref_index--;
        this.ref = this.article_data.bibitems[pos];
        scrollToElt("ref-" + pos);
      }
    },
    go(pos) {
      if (pos >= 0 && pos < this.article_data.bibitems.length) {
        this.ref_index = pos;
        this.ref = this.article_data.bibitems[pos];
        scrollToElt("ref-" + pos);
      }
    },
    async firstSaveForm(goto_next_url) {
      return new Promise((resolve, reject) => {
        this.saveForm(goto_next_url)
        setTimeout(() => {
          resolve("First function result");
        }, 1000);
      });
    },
    async nextPCJ(goto_next_url, PCJSubmissionURL) {
      const response = await this.firstSaveForm(goto_next_url)
      if (this.is_pcj_article_valid) {
        // window.location.replace(PCJSubmissionURL)
        this.setSubmissionFormDirty(false)
        window.location.href = PCJSubmissionURL
      } else {
        return
      }
    },
    checkTopics() {
      let topicsSet = new Set(this.topics)
      if (topicsSet.size <= 1) {
        this.is_topics_checkbox_mandatory = true
      } else {
        this.is_topics_checkbox_mandatory = false
      }
    },
    checkArticleValidity() {
      if (this.title_text) {
        this.is_pcj_title_article_provided = true
      } else {
        this.is_pcj_title_article_provided = false
      }
      if (this.abstract_text) {
        this.is_pcj_article_abstract_provided = true
      } else {
        this.is_pcj_article_abstract_provided = false
      }
      if (!this.is_topics_checkbox_mandatory) {
        this.is_topic_valid = true
      } else if (this.is_single_topic_override == true || this.is_single_topic_override == "true") {
        this.is_topic_valid = true
      } else {
        this.is_topic_valid = false
      }
      if (
        this.is_pcj_title_article_provided
        && this.is_pcj_article_abstract_provided
        && this.is_topic_valid
      ) {
        this.is_pcj_article_valid = true
      } else {
        this.is_pcj_article_valid = false
      }
    },
    saveForm(goto_next_url) {
      this.article_data.title_tex = this.title_text;
      this.article_data.is_single_topic_override = this.is_single_topic_override;
      if (this.isPCJ) {
        if (this.title_text) {
          this.is_pcj_title_article_provided = true
        } else {
          this.is_pcj_title_article_provided = false
        }
        if (this.abstract_text) {
          this.is_pcj_article_abstract_provided = true
        } else {
          this.is_pcj_article_abstract_provided = false
        }
        if (!this.is_topics_checkbox_mandatoryd) {
          this.is_topic_valid = true
        } else if (!this.is_single_topic_override) {
          this.is_topic_valid = false
        }
        if (
          this.is_pcj_title_article_provided
          && this.is_pcj_article_abstract_provided
          && this.is_topic_valid
        ) {
          this.is_pcj_article_valid = true
        } else {
          this.is_pcj_article_valid = false
        }
      }
      this.article_data.trans_title_tex = this.transtitle_text;
      if (this.article_data["abstracts"].length > 0) {
        this.article_data.abstracts[0].value_tex = this.abstract_text;
      }
      if (this.article_data["abstracts"].length > 1) {
        this.article_data.abstracts[1].value_tex = this.transabstract_text;
      }

      var list_ = this.kwds_text.split("\n");
      for (let i = 0; i < list_.length; i++) {
        if (list_[i] != "" && list_[i] != " ") {
          this.article_data.kwds.push({
            type: "",
            lang: this.article_data.lang,
            value: list_[i],
          });
        }
      }

      let trans_lang = "fr";
      if (this.article_data.lang == "fr") {
        trans_lang = "en";
      }

      list_ = this.trans_kwds_text.split("\n");
      for (let i = 0; i < list_.length; i++) {
        if (list_[i] != "" && list_[i] != " ") {
          if (this.isTrad && !this.is_kwd_already_translated) {
            this.trans_article.kwds.push({
              type: "",
              lang: this.trans_article.lang,
              value: list_[i],
            });
          } else {
            this.article_data.kwds.push({
              type: "",
              lang: trans_lang,
              value: list_[i],
            });
          }
        }
      }

      var save_button_text = document.getElementById("id-save-text");
      const errors = {
        "is_bititem_title_missing": [],
        "is_bibitem_author_missing": [],
        "is_bibitem_year_missing": [],
        "is_wrong_doi": [],
        "is_author_orcid_invalid": [],
        "is_author_ror_invalid": [],
        "is_volume_over_max_length": [],
      }
      const error_messages = {
        "is_bititem_title_missing": "The following reference(s) have no title",
        "is_bibitem_author_missing": "The following reference(s) have no author",
        "is_bibitem_year_missing": "The following reference(s) have no year",
        "is_wrong_doi": "The following reference(s) have a wrong DOI",
        "is_author_orcid_invalid": "The following author(s) have an invalid ORCID",
        "is_volume_over_max_length": "The following volume(s) exceeds max length of 32 characters"
      }

      this.article_data.bibitems.forEach((bibitem, i) => { // Check for title. Different types have different attributes for the title.
        this.article_data.bibitems[i].is_bititem_title_missing = false
        this.article_data.bibitems[i].is_bibitem_author_missing = false
        this.article_data.bibitems[i].is_bibitem_year_missing = false
        this.article_data.bibitems[i].is_volume_over_max_length = false

        if (['book', 'phdthesis', 'proceedings'].includes(bibitem.type)) {
          if (!bibitem.source_tex) {
            errors.is_bititem_title_missing.push(i + 1)
            this.article_data.bibitems[i].is_bititem_title_missing = true
          }
        }
        else if (['article', 'misc'].includes(bibitem.type)) {
          if (!bibitem.article_title_tex) {
            errors.is_bititem_title_missing.push(i + 1)
            this.article_data.bibitems[i].is_bititem_title_missing = true
          }
        }
        else if (['incollection', 'inproceedings', 'inbook'].includes(bibitem.type)) {
          if (!bibitem.chapter_title_tex) {
            errors.is_bititem_title_missing.push(i + 1)
            this.article_data.bibitems[i].is_bititem_title_missing = true
          }
        }
        else if (!bibitem.title_tex) {
          errors.is_bititem_title_missing.push(i + 1)
          this.article_data.bibitems[i].is_bititem_title_missing = true
        }

        if (!bibitem.contribs_text) { // Author
          errors.is_bibitem_author_missing.push(i + 1)
          this.article_data.bibitems[i].is_bibitem_author_missing = true
        }
        if (!bibitem.year) {
          errors.is_bibitem_year_missing.push(i + 1)
          this.article_data.bibitems[i].is_bibitem_year_missing = true
        }
        if (bibitem?.volume.length > 32) { // Max length auhtorized by Crossref
          errors.is_volume_over_max_length.push(i + 1)
          this.article_data.bibitems[i].is_volume_over_max_length = true
        }

        if (this.checkRefDoi(i)) {
          errors.is_wrong_doi.push(i + 1)
        }
      })

      this.article_data.contributors.forEach((contributors, i) => {
        this.article_data.contributors[i].is_author_orcid_invalid = false
        this.article_data.contributors[i].is_author_ror_invalid = false
        if (contributors.orcid && !contributors.orcid.match((/\w{4}-\w{4}-\w{4}-\w{4}/))) {
          errors.is_author_orcid_invalid.push(i + 1)
          this.article_data.contributors[i].is_author_orcid_invalid = true
        }
      })

      this.$forceUpdate(); // Shows error frames. TODO unoptimal

      const outputLines = [];
      if (this.isPCJ) {
        for (const type of ["is_bititem_title_missing", "is_bibitem_author_missing", "is_bibitem_year_missing", "is_wrong_doi", "is_author_orcid_invalid", "is_volume_over_max_length"]) {
          if (errors[type].length > 0) {
            const indices = errors[type].join(", n°");
            outputLines.push(` - ${error_messages[type]}: n°${indices}`);
          }
        }

      }

      if (outputLines.length > 0) {
        save_button_text.innerHTML = "Error:<br>" + outputLines.join("<br>");
        return;
      }


      this.article_data.topics = Array.from(new Set(this.topics));

      if (this.isTrad) {
        this.trans_article.body_html = this.fixCkeditorText(this.removeCss(this.trans_body_html));

        if (!this.is_abstract_already_translated) {
          this.trans_article.abstracts[0].value_tex = this.fixCkeditorText(this.trans_abstract_text);
        }

        if (!this.is_title_already_translated) {
          this.trans_article.title_tex = this.fixCkeditorText(this.trans_article.title_tex);
        }

        this.article_data.translations.push(this.trans_article);
      }

      save_button_text.innerHTML = "Saving data...";
      var url = "api-article-edit/" + this.colid + "/" + this.doi + "/";
      if (this.isTrad) {
        url = "api-article-edit/" + this.colid + "/" + this.doi + "/" + this.translation_id + "/";
      }

      var next_url = "";
      if (goto_next_url && this.article_data.next_url) {
        next_url = this.article_data.next_url;
      }
      const formData = new FormData();
      formData.append('icon', this.selectedIconFile);
      formData.append('data', JSON.stringify(this.article_data));
      axios
        .post(url, formData)
        .then((response) => {
          save_button_text.innerHTML = "Data saved";
          if (goto_next_url && next_url) {
            this.setSubmissionFormDirty(false)
            save_button_text.innerHTML = "";
            window.location.href = next_url;
          } else if (this.isPCJ) {
            this.$nextTick(() => {
              $("#article_topics").selectpicker();
            })

          }

          setTimeout(function () {
            var save_button = document.getElementById("id-save");
            this.is_submission_dirty = false
            save_button.classList.remove("btn-needs-save");
            save_button_text.innerHTML = "";
          }, 1000);
        })
        .catch((error) => {
          save_button_text.innerHTML = "Error while saving data";
        })
        .finally(() => {
          this.prepare_kwds();
        });
    },
    insert_abstract() {
      this.article_data["abstracts"] = [
        {
          tag: "abstract",
          lang: "en",
          value_html: "",
          value_tex: "",
        },
      ];
    },
    insert_author() {
      var contrib = {
        first_name: "",
        last_name: "",
        prefix: "",
        suffix: "",
        orcid: "",
        email: "",
        string_name: "",
        mid: "",
        addresses: [],
        address_text: "",
        ror: [],
        role: "author",
        deceased_before_publication: false,
        equal_contrib: false,
        contrib_xml: '<contrib equal-contrib="yes"><name><surname></surname><given-names></given-names></name></contrib>',
        corresponding: false,
      };
      if (this.isTrad) {
        contrib["role"] = "translator";
        this.trans_article["contributors"].push(contrib);
        var index = 0;
        if (this.trans_article["contributors"].length > 0) {
          index = this.trans_article["contributors"].length - 1;
        }
        scrollToElt("section-contribs-trans-" + index);
      } else {
        this.article_data["contributors"].push(contrib);
        var index = 0;
        if (this.article_data["contributors"].length > 0) {
          index = this.article_data["contributors"].length - 1;
        }
        scrollToElt("section-contribs-" + index);
      }
    },
    insert_kwds() {
      if (!this.kwds_text.length) {
        this.kwds_text = " ";
      }
      scrollToElt("section-keywords");
    },
    prepare_kwds() {
      this.kwds_text = "";
      this.trans_kwds_text = "";
      let other_kwds = [];
      for (let i = 0; i < this.article_data.kwds.length; i++) {
        let kwd = this.article_data.kwds[i];
        if (kwd["type"] != "msc" && kwd["lang"] == this.article_data.lang) {
          this.kwds_text += kwd["value"] + "\n";
        } else if (kwd["type"] != "msc") {
          if (this.isTrad && kwd["lang"] == this.trans_article.lang) {
            this.is_kwd_already_translated = true;
          }
          this.trans_kwds_text += kwd["value"] + "\n";
        } else {
          // msc keywords
          other_kwds.push(kwd);
        }
      }
      this.article_data.kwds = other_kwds;

      if (this.isTrad) {
        for (let i = 0; i < this.trans_article.kwds.length; i++) {
          this.trans_kwds_text += this.trans_article.kwds[i]["value"] + "\n";
        }
        this.trans_article.kwds = [];
      }
    },
    insert_subj() {
      this.article_data.subjs.push({
        lang: "",
        type: "subject",
        value: "",
        seq: this.article_data.subjs.length,
      });
      scrollToElt("section-subjs");
    },
    delete_key(key) {
      this.article_data[key] = "";
    },
    delete_field(obj, pos) {
      obj.splice(pos, 1);
    },
    delete_bibitem(obj) {
      obj.splice(this.ref_index, 1);
      this.prev();
    },
    delete_all_bibitems(obj) {
      this.article_data.bibitems.splice(0, this.article_data.bibitems.length);
    },
    delete_icon_file() {
      this.article_data.icon_url = "";
      this.selectedIconFile = null;
      this.iconFilePreview = null;
      var elt = document.getElementById("icon-file-input");
      elt.value = "";
    },
    stringName(first_name, last_name) {
      var string_name = "";
      if (last_name !== "") {
        string_name += last_name + ", ";
      }
      return string_name + first_name;
    },
    toggleMoreAuthorFieldsText(pos) {
      const element = this.$refs.more_fields[pos];
      if (element.innerText.includes("More fields")) {
        element.innerHTML = '<i class="bi bi-chevron-up"></i> Less fields';
      } else {
        element.innerHTML = '<i class="bi bi-chevron-down"></i> More fields';
      }
    },
    setChangeRef(value) {
      this.change_ref = value;
      this.modal_ref_index = this.article_data.bibitems.length ? this.ref_index + 2 : this.ref_index + 1;
      this.modal_title = value == true ? "Change reference type" : "Create new reference";
    },
    setRefIndex(index) {
      this.ref_index = index + 1;
    },
    insertNewRef(type, index) {
      let newRef = {
        type: type,
        contribs_text: "",
        contributors: [],
        label: "",
        publisher_name: "",
        publisher_loc: "",
        institution: "",
        series: "",
        volume: "",
        issue: "",
        month: "",
        year: "",
        comment: "",
        annotation: "",
        fpage: "",
        lpage: "",
        page_range: "",
        size: "",
        source_tex: "",
        article_title_tex: "",
        chapter_title_tex: "",
        citation_tex: "",
        extids: [],
        ext_links: [],
        eid: "",
        user_id: "",
        doi: "",
      };

      let i = parseInt(index);
      if (i > this.article_data.bibitems.length) {
        this.article_data.bibitems.push(newRef);
      } else {
        this.article_data.bibitems.splice(i, 0, newRef);
      }
      this.go(index);
    },
    getTitleKeyFromType(type) {
      let key = "";
      if (type == "article" || type == "misc") {
        key = "article_title_tex";
      } else if (type == "inbook") {
        key = "chapter_title_tex";
      } else if (type == "unknown") {
        key = "citation_tex";
      } else {
        key = "source_tex";
      }
      return key;
    },
    getCollectionKeyFromType(type) {
      let key = "";
      if (type == "article" || type == "inbook") {
        key = "source_tex";
      } else {
        key = "series";
      }
      return key;
    },
    insertRefOrChangeRefType(type) {
      if (this.change_ref) {
        let ref = this.article_data.bibitems[this.ref_index];
        let old_type = ref["type"];
        ref["type"] = type;

        let old_title_key = this.getTitleKeyFromType(old_type);
        let old_collection_key = this.getCollectionKeyFromType(old_type);
        let old_title = ref[old_title_key];
        let old_collection = ref[old_collection_key];
        let new_title_key = this.getTitleKeyFromType(type);
        let new_collection_key = this.getCollectionKeyFromType(type);

        ref["article_title_tex"] = ref["chapter_title_tex"] = ref["source_title_tex"] = ref["series"] = "";
        if ((old_type == "article" || old_type == "misc" || old_type == "chapter") && (type == "book" || type == "phdthesis")) {
          ref["fpage"] = ref["lpage"] = ref["page_range"] = "";
        }
        if ((old_type == "article" || old_type == "misc") && type != "article" && type != "misc") {
          ref["page_range"] = "";
        }
        if ((old_type == "book" || old_type == "phdthesis") && (type == "article" || type == "chapter" || type == "misc")) {
          ref["size"] = "";
        }

        ref[new_title_key] = old_title;

        if (old_type != "unknown") {
          ref[new_collection_key] = old_collection;
        } else {
          ref["contributors"] = [];
        }
        ref["citation_tex"] = "";
      } else {
        this.insertNewRef(type, this.modal_ref_index - 1);
      }
      this.closeModal();
    },
    moveRef(step) {
      var pos = this.ref_index + step;
      if (pos >= 0 && pos < this.article_data.bibitems.length) {
        var refs = this.article_data.bibitems.splice(this.ref_index, 1);
        this.article_data.bibitems.splice(pos, 0, refs[0]);
        this.ref_index = pos;
      }
    },
    sortRef() {
      var bibitems = this.article_data.bibitems;
      var new_bibitems = bibitems.sort(function (biba, bibb) {
        var a_text = "";
        var b_text = "";
        if (biba.contribs_text) {
          a_text = biba.contribs_text;
        } else {
          a_text = biba.citation_tex;
        }

        if (bibb.contribs_text) {
          b_text = bibb.contribs_text;
        } else {
          b_text = bibb.citation_tex;
        }
        if (a_text > b_text) {
          return 1;
        }
        if (a_text < b_text) {
          return -1;
        }
        return 0;
      });
      this.article_data.bibitems = new_bibitems;
    },
    updateBibtex(url, data) {
      var spinner = document.getElementById("spinner-doi-ref");
      const csrf_token = document.querySelector("[name=csrfmiddlewaretoken]").value;

      axios({
        method: "POST",
        url: url,
        headers: {
          "X-CSRFTOKEN": csrf_token,
          "Content-Type": "application/json",
        },
        data: data,
      })
        .then((response) => {
          if (response.data.length > 0) {
            this.ref = null;
            //this.article_data.bibitems.splice(0, this.article_data.bibitems.length);
            for (var i = 0; i < response.data.length; i++) {
              var type = response.data[i].type;
              if (type == "techreport" || type == "unpublished") {
                response.data[i].type = "phdthesis";
              } else if (type == "inbook" || type == "inproceedings") {
                response.data[i].type = "incollection";
              }
              this.article_data.bibitems.splice(i + this.article_data.bibitems.length, 1, response.data[i]);
              this.checkRefDoi(i);
            }
            this.go(0);
          } else {
            var elt_text = document.getElementById("id-getrefs-text");
            elt_text.innerHTML = "No DOI found, check your file.";
            setTimeout(function () {
              elt_text.innerHTML = "";
            }, 2000);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          spinner.style.visibility = "hidden";
          scrollToElt("section-bibitems");
        });
    },
    async getBibTexRef(event) {
      var spinner = document.getElementById("spinner-doi-ref");
      spinner.style.visibility = "visible";
      const name = event.target.name;
      const file = event.target.files[0];

      const data = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (load) => resolve(load.target.result);
        reader.onerror = (error) => console.log(error);
        reader.readAsText(file);
      });
      this.updateBibtex(name + "/", {
        data: data,
      });
    },
    moveAuthor(index, step) {
      if (this.isTrad) {
        var authors = this.trans_article["contributors"].splice(index, 1);
        this.trans_article["contributors"].splice(index + step, 0, authors[0]);
      } else {
        var authors = this.article_data["contributors"].splice(index, 1);
        this.article_data["contributors"].splice(index + step, 0, authors[0]);
      }
    },
    fetchRefDoi(doi) {
      var url = "fetch-ref/" + this.ref_index + "/" + doi + "/";
      axios.get(url).then((response) => {
        this.article_data.bibitems.splice(this.ref_index, 1);
        this.article_data.bibitems.splice(this.ref_index, 0, response.data);
        this.ref = this.article_data.bibitems[this.ref_index];
      });
    },
    checkRefDoi(index) {
      let wrong_doi = false;
      let ref = this.article_data.bibitems[index];
      if (ref.doi === null) {
        ref.doi = "";
      }
      const doi = ref.doi.trim();
      if (doi.length > 0 && (doi.length < 4 || !(doi.includes("10.") || doi.includes("10/")))) { // Includes because DOI string can be full URL
        wrong_doi = true;
      }

      ref.doi = doi;
      ref.wrong_doi = wrong_doi;

      return wrong_doi;
    },
    closeModal() {
      this.$emit("close");
    },
    sendInfo(index) {
      this.author_index = index;
    },
    fixCkeditorText(value) {
      // CKEditor adds '\n' at the end of HTML text
      // editor.dataProcessor.writer.lineBreakChars = ''; (see below) does not seem to work
      return value.replace(/\n/g, "");
    },
    onEditorReady(editor) {
      editor.dataProcessor.writer.indentationChars = "";
      editor.dataProcessor.writer.lineBreakChars = "";
      editor.dataProcessor.writer.setRules("br", {
        indent: false,
        breakBeforeOpen: false,
        breakAfterOpen: false,
        breakBeforeClose: false,
        breakAfterClose: false,
      });
    },
    onFullTextEditorReady(editor) {
      this.onEditorReady(editor);
      editor.on("contentDom", function () {
        var editable = editor.editable();
        var win = this.document.getWindow();

        // scrollbars synchronization
        editable.attachListener(editable.getDocument(), "scroll", function () {
          if (document.getElementById("synchScroll").checked) {
            var scroll = win.getScrollPosition();
            var scroll_percent = (100 * parseInt(scroll.y)) / parseInt(editable.$.scrollHeight);
            var vo_scroll = (scroll_percent * parseInt(document.getElementById("fulltext-zone").scrollHeight)) / 100;

            document.getElementById("fulltext-zone").scrollTop = vo_scroll;
          }
        });
      });
    },
    areTranslatorsComplete() {
      var is_complete = true;
      for (let i = 0; i < this.trans_article["contributors"].length; i++) {
        let contrib = this.trans_article["contributors"][i];
        if (contrib["first_name"].length == 0 || contrib["last_name"].length == 0 || contrib["email"].length == 0) {
          is_complete = false;
        }
      }
      return is_complete;
    },
    isTranslatedArticleComplete() {
      let is_complete = true;
      if ("unset" in this.trans_article) {
      } else {
        if (
          !this.areTranslatorsComplete() ||
          (!this.is_title_already_translated && !this.trans_article.title_tex.length) ||
          (!this.is_abstract_already_translated && !this.trans_abstract_text.length) ||
          (!this.is_kwd_already_translated && this.kwds_text.length && !this.trans_kwds_text.length) ||
          this.trans_body_html == this.getCssText()
        ) {
          is_complete = false;
        }
      }
      return is_complete;
    },
    isPcjSubmissionReady() {
      let is_ready = false
      if (this.title_text.length) {
        is_ready = true
      }
      return is_ready
    },
    getCssText() {
      return '<style type="text/css">img { max-width: 100%; }\n</style>';
    },
    addCss(html_text) {
      // CSS added in the translated html to resize images according to the container (ckeditor). Removed in saveForm().
      var css_text = this.getCssText();

      if (html_text.includes(css_text)) {
        return html_text;
      } else {
        return html_text + css_text;
      }
    },
    removeCss(html_text) {
      var css_text = this.getCssText();
      return html_text.replace(css_text, "");
    },
    scrollTo(id) {
      scrollToElt(id);
    },
    handleIconFileSelect(event) {
      const file = event.target.files[0];
      this.selectedIconFile = file;
      this.previewFile(file, this.setIconPreview);
    },
    setIconPreview(filePreview) {
      this.iconFilePreview = filePreview;
    },
    setSubmissionFormDirty(isDirty) {
      var save_button = document.getElementById("id-save");
      this.is_submission_dirty = isDirty
      if (isDirty) {
        save_button.classList.add("btn-needs-save");
      }
      else {
        save_button.classList.remove("btn-needs-save");
      }
    },
    previewFile(file, callback) {
      const reader = new FileReader();
      reader.onload = () => {
        callback(reader.result);
      };
      reader.readAsDataURL(file);
    },
    isImage(file) {
      return file && file.type.startsWith('image/');
    },
    isTopicMandatory(topic) {
      var value = this.article_data.pci_section != "" &&
        this.article_data.pci_section in mandatory_topics &&
        mandatory_topics[this.article_data.pci_section] == topic;
      return value;
    },
    handlePasteWithRegex(event, contrib, field, regex) {
      event.preventDefault();
      const pasteData = (event.clipboardData || window.Clipboard).getData("text");
      const match = pasteData.match(regex);
      if (match) {
        contrib[field] = match[0];
      }
    },

    handleOrcidInputPaste(event, contrib) {
      // ORCID format: 0000-0000-0000-0000
      const orcidRegex = /\b\d{4}-\d{4}-\d{4}-\d{4}\b/;
      this.handlePasteWithRegex(event, contrib, "orcid", orcidRegex);
    },

  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      if (value == "inbook" || value == "incollection" || value == "inproceedings") value = "chapter";
      else if (value == "proceedings" || value == "book") value = "book";
      else if (value == "phdthesis" || value == "techreport" || value == "unpublished") value = "thesis";
      else if (value == "article") value = "article";
      else value = "misc";

      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    formula: function (value) {
      value = value.replaceAll("\\(", "\\\\(");
      value = value.replaceAll("\\)", "\\)");
      return value;
    },
  },
  watch: {
    abstract_text: function () {
      this.$nextTick(function () {
        getML(this.article_data, "abstract-text");
      });
    },
    transabstract_text: function () {
      this.$nextTick(function () {
        getML(this.article_data, "transabstract-text");
      });
    },
    title_text: function () {
      this.$nextTick(function () {
        getML(this.article_data, "title-text");
      });
    },
    transtitle_text: function () {
      this.$nextTick(function () {
        getML(this.article_data, "transtitle-text");
      });
    },
    topics: {
      handler: function () {
        this.setSubmissionFormDirty(true)
        this.checkArticleValidity();
      }
    },
    article_data: {
      handler: function () {
        this.setSubmissionFormDirty(true)
        this.checkArticleValidity();
        /* Autosave does not work right now because saveForm() updates this.article_data
           We therefore enter an infinite loop (saveForm -> article_data watch handler -> saveForm)
           if ('unset' in this.trans_article) {
             console.log('handle: article unset');
          } else {
              this.$nextTick(function() {
                console.log("calling clearTimeout", this.wto);
                  clearTimeout(this.wto);
                  var self = this;
                  this.wto = setTimeout(function() {
                     console.log("watch - call saveForm");
                     self.saveForm();
                  }, 400);
              });
          } */
      },
      deep: true,
    },
    kwds_text: {
      handler: function () {
        this.setSubmissionFormDirty(true)
        this.checkArticleValidity();
      }
    },
    trans_kwds_text: {
      handler: function () {
        this.setSubmissionFormDirty(true)
        this.checkArticleValidity();
      }
    }
  },
};
</script>

<style>
:root {
  /* Font families */
  /* ----------------------------------------------------------------------*/
  /* Used for interface elements */
  --t-interface-font: "Inter UI", system-ui, sans-serif;
  /* Used for flowing text, such as paragraphs */
  --t-text-font: "Inter UI", system-ui, sans-serif;
  /* used for code, URLS, etc */
  --t-code-font: Monaco, "Courier New";
  /* Font sizes */
  /* ----------------------------------------------------------------------*/
  /* Used for main text */
  --t-text-font-size: 17px;
  /* Used for authors list */
  --t-large-font-size: 19px;
  /* Table of contents */
  --t-small-font-size: 14px;
  /* Used in toolbars and section labels */
  --t-tiny-font-size: 12px;
  /* Used in toolbar dropdown menus */
  --t-dropdown-font-size: 11px;
  /* E.g. article title */
  --t-title-font-size: 15px;
  /* Heading level 1 */
  --t-h1-font-size: 23px;
  /* Heading level 2 */
  --t-h2-font-size: 21px;
  /* Heading level 3 */
  --t-h3-font-size: 19px;
  /* Heading level 4 */
  --t-h4-font-size: 17px;
  /* Font weights */
  /* ----------------------------------------------------------------------*/
  --t-normal-font-weight: 400;
  /* Normal text weight */
  --t-bold-font-weight: 500;
  /* Strong emphasis */
  /* Line heights */
  /* ----------------------------------------------------------------------*/
  /* Used in main text */
  --t-default-line-height: 1.5;
  /* Colors */
  /* ----------------------------------------------------------------------*/
  /* Default background color, used when we need to cover content, e.g. in overlays */
  --t-background-color: #fff;
  /* Light (greyish) background color */
  --t-light-background-color: #2e72ea0a;
  /* Background for action buttons */
  --t-action-background-color: #4e4e4e;
  /* Button backgorund */
  --t-default-button-background: #f7f7f9;
  /* Main text color, used in the article */
  --t-text-color: #111;
  /* Used to display error message */
  --t-error-text-color: #c80000;
  /* Inverted text color, to put on dark elements */
  --t-inverted-text-color: #fff;
  /* Used for section labels, card labels etc. */
  --t-light-text-color: #888;
  /* Used for input placeholders */
  --t-placeholder-text-color: #ccc;
  /* Used for focus border, e.g. selected card, or text input */
  --t-focus-color: rgb(145, 189, 240);
  /* E.g. citations of references, figures, etc. */
  --t-action-color: #2e72ea;
  /* Used to display warning icons */
  --t-warning-color: #ffaf46;
  /* Used to display error message */
  --t-error-color: rgba(200, 0, 0, 0.25);
  /* Default light border color */
  --t-border-color: #ddd;
  --info-background-color: #c5dbd3;
  --primary-color: #24afad;
  /* Paddings */
  /* ----------------------------------------------------------------------*/
  --t-half-spacing: 10px;
  /* Half of the default spacing */
  --t-default-spacing: 15px;
  /* Default padding to create some whitespace, e.g. in figure */
  --t-text-spacing: 15px;
  /* Used as the margin between content elements */
  --t-double-spacing: 5px;
  /* Double of the default spacing */
  --t-input-padding: 4px;
  /* Padding used input boxes */
  --t-cell-padding: 6px;
  /* Padding used table cells */
  --t-button-padding: 7px;
  /* Padding used by buttons */
  /* Margins */
  /* ----------------------------------------------------------------------*/
  --t-flowing-content-margin: 20px 0;
  /* Space between content elements, e.g. between two paragraphs */
  /* Borders */
  /* ----------------------------------------------------------------------*/
  --t-input-default-border: 2px solid transparent;
  --t-input-outline-border: 2px solid var(--t-border-color);
  --t-input-focus-border: 2px solid rgb(145, 189, 240);
  --t-negative-input-padding: -6px;
  /* This must be the negative of input padding + default border width */
  --t-negative-list-padding: -4px;
  /* Same, but without borders. Used in comma-separated lists. */
  --t-border-radius: 5px;
  /* Default border radius for rounded corners */
  --t-tool-border-radius: 3px;
  /* Default border radius for tools */
  --t-default-border: 1px solid var(--t-border-color);
  --info-border-color: #24afdf;
  /* Box shadows */
  /* ----------------------------------------------------------------------*/
  --t-default-box-shadow: 0 0 0 0.75pt #d1d1d1, 0 0 3pt 0.75pt #ccc;
  --t-popup-box-shadow: 0 2px 10px -2px rgba(0, 0, 0, 0.8);
  /* Substance Styles */
  /* ----------------------------------------------------------------------*/
  --t-small-layout-width: 300px;
  --t-medium-layout-width: 620px;
  --t-large-layout-width: 960px;
  --t-separator-color: rgba(0, 0, 0, 0.05);
}

#article {
  font-family: var(--t-interface-font);
  text-align: left;
  margin-bottom: var(--t-text-spacing);
}

#id-save-text,
#id-getrefs-text {
  background-color: #f9fbc1;
  color: red;
  font-size: 12px;
  content: " ";
}

h1 {
  font-size: 23px;
}

h2 {
  font-size: 21px;
}

h3 {
  font-size: 19px;
}

h4 {
  font-size: 17px;
}

.sc-text-input {
  width: 100%;
  border-radius: 5px;
  padding: var(--t-input-padding);
  border: var(--t-input-default-border);
  margin: var(--t-negative-input-padding);
  color: var(--t-text-color);
  background-color: transparent !important;
  font-weight: var(--t-normal-font-weight);
  font-family: var(--t-interface-font);
}

.sc-textarea-input {
  width: 100%;
  resize: vertical;
  height: 5em;
}

.sc-textarea-input-tall {
  height: 10em;
}

/*.sc-text-input.sm-editable .se-input:hover*/
input[type="text"]:focus {
  border: var(--t-input-focus-border) !important;
  outline: transparent;
}

.article-heading {
  display: flex;
  justify-content: space-between;
  max-width: 800px;
  margin: 30px 0px 0px 0px;
  border-radius: 4px;
  font-size: var(--t-h1-font-size);
  cursor: default;
}

.sc-card {
  position: relative;
  width: 100%;
  box-shadow: var(--t-default-box-shadow);
  margin: var(--t-double-spacing) 0;
  margin-top: var(--t-text-spacing);
  font-size: var(--t-small-font-size);
}

.sc-card.sm-selected {
  outline: var(--t-input-focus-border);
}

.sc-card>.se-label {
  position: absolute;
  top: -10px;
  left: var(--t-double-spacing);
  padding: 0px var(--t-default-spacing);
  background: var(--t-background-color);
  color: var(--t-light-text-color);
  cursor: default;
}

.sc-card.sm-selected>.se-label {
  background: var(--t-focus-color);
  color: var(--t-inverted-text-color);
}

.sc-card .sc-form-row {
  margin: var(--t-default-spacing) 0;
}

.sc-card>* {
  padding: var(--t-default-spacing);
}

.sc-card>*>.se-header {
  font-size: var(--t-text-font-size);
  margin-bottom: var(--t-default-spacing);
  margin-top: 0px;
  cursor: default;
}

.sc-card>*>.se-footer {
  display: flex;
  justify-content: space-between;
  margin: 0;
}

.sc-card>*>.se-footer>.se-control {
  font-size: 12px;
  color: var(--t-action-color);
  cursor: pointer;
  margin-bottom: 0px;
}

.sc-card>*>.se-footer>.se-control>.se-icon {
  margin-right: 10px;
}

.sc-card,
.sc-plus {
  margin-left: 10px;
}

.sc-card-ref {
  min-height: 650px;
  margin-left: 0px;
  box-shadow: none;
}

.sc-form-row {
  position: relative;
  display: flex;
  align-items: center;
}

.sc-form-row>.se-label {
  cursor: default;
  display: block;
  flex: 0 0 90px;
  font-size: var(--t-tiny-font-size);
  color: var(--t-light-text-color);
}

.sc-form-row>.se-label::after {
  content: ":";
}

.sc-form-row>.se-editor {
  width: 100%;
  border: 1px solid #ddd;
}

.sc-form-row.invalid-field>.se-label {
  color: red;
  font-weight: bold;
  font-size: large;
}

.sc-form-row.invalid-field>.se-editor,
.sc-form-row.invalid-field>.sc-textarea-input {
  border: 2px solid red;
}

.sc-form-row.invalid-field>.se-editor:focus {
  border: 2px solid red !important;
}

.with-delete {
  max-width: 840px;
}

.more-fields {
  font-size: var(--t-tiny-font-size);
  text-decoration: none;
}

.ref-type {
  padding-bottom: 0px;
}

.ref-content {
  padding-top: 0px;
}

.ref-unknown {
  color: red !important;
  font-weight: bold;
}

.bottom-screen {
  position: fixed;
  height: 80px;
  bottom: 80px;
  left: 20px;
}

.btn-sm {
  padding: 0.05rem 0.3rem;
  border-color: transparent;
}

.btn-primary,
.btn-primary:focus,
.btn-primary:active {
  background-color: #87a2b1;
  border-color: #87a2b1;
  box-shadow: none;
  transition: none;
}

.btn-space {
  margin-left: 5px;
  margin-right: 5px;
}

.btn-needs-save {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.btn-primary-trad.btn-needs-save {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}

.ref-preview {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
}

#ref-preview-left {
  height: 43rem;
  width: 98%;
  min-width: 10vw;
  max-width: 60vw;
  overflow-x: hidden;
  overflow-y: auto;
  border: 1px solid;
}

#ref-preview-right {
  font-size: 14px;
  margin-left: var(--t-text-spacing);
  height: 43rem;
  width: 98%;
  min-width: 10vw;
  max-width: 90vw;
  background-color: #f0f0f0;
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid;
}

.splitpanes.default-theme .splitpanes__pane {
  background-color: rgba(255, 255, 255, 0.9);
}

.default-theme.splitpanes--vertical>.splitpanes__splitter {
  width: 11px;
  border-left: 1px solid #eee;
  margin-left: -5px;
  border-right: 1px solid #eee;
}

.default-theme.splitpanes--vertical>.splitpanes__splitter::after,
.default-theme.splitpanes--vertical>.splitpanes__splitter::before {
  transform: translateY(-50%);
  width: 2px;
  height: 40px;
  background-color: #6c004d;
}

.ref-selected {
  color: blue;
}

.ref-selected:link,
.ref-selected:visited {
  color: blue;
  text-decoration: none;
}

.ref-selected:hover,
.ref-selected:active,
.ref-selected:focus {
  color: #22427c;
}

.ref-unselected {
  color: black;
}

.ref-unselected:link,
.ref-unselected:visited {
  color: black;
  text-decoration: none;
}

.ref-unselected:hover,
.ref-unselected:active,
.ref-unselected:focus {
  color: #22427c;
}

ul.no-bullets {
  padding: 0;
  list-style-type: none;
}

li.bib-list {
  margin-bottom: 5px;
}

#sidebar-menu {
  width: 100px;
  position: fixed;
  z-index: 1;
  top: 250px;
  left: 10px;
}

#sidebar-menu a {
  display: block;
  padding: 0.5rem 1rem;
  color: #888;
  text-decoration: none;
  font-size: 14px;
}

#sidebar-menu a.current {
  background: #e4eef3;
}

#sidebar-menu a:hover {
  color: #064579;
}

section {
  padding-top: 0px;
}

input[type="number"] {
  width: 70px;
  padding: 4px 6px;
  border: 1px solid #bbb;
  border-radius: 7px;
}

img {
  max-width: 50%;
  height: auto !important;
}

img.article-body-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-width: 100%;
  height: auto;
}

.se-ref-header-label {
  margin-left: 10px;
  font-size: var(--t-small-font-size);
  color: var(--t-light-text-color);
}

#fulltext-zone {
  height: 500px;
  width: 100%;
  overflow-y: scroll;
  border: 1px solid #d1d1d1;
  margin-top: 20px;
  padding: 20px;
  color: #6c757d;
  font-size: 13px;
  font-family: Verdana, sans-serif;
}

#fulltext-zone figure {
  text-align: center;
  outline: solid 1px #ccc;
  background: rgba(0, 0, 0, 0.05);
  padding: 10px;
  margin: 10px 20px;
  display: inline-block;
}

span.required-field {
  color: red;
}

#info_to_fill {
  background-color: var(--info-background-color);
  border-color: var(--info-border-color);
}

.btn-primary-trad {
  color: var(--primary-color);
  border-color: var(--primary-color);
}

.btn-primary-trad:hover {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

a.anchor {
  display: block;
  position: relative;
  top: -250px;
  visibility: hidden;
}

.with-anchor {
  padding-top: 160px;
  margin-top: -160px;
}

.info-not-editable {
  margin-top: -24px;
}

.max-800 {
  max-width: 800px;
}

.max-1200 {
  max-width: 1200px;
}

.bootstrap-select .selected {
  background-color: #e4eef3;
}

.bootstrap-select .selected.disabled {
  background-color: lightblue;
}

.bootstrap-select.sc-text-input {
  margin-left: -6px;
}

.bootstrap-select .btn-sm {
  padding: 0px;
  padding-left: 4px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}

.topic-mandatory {
  background-color: lightblue;
}
</style>
